<template>
  <div class="main-popup request-view" :class="{'is-edit-mode': isEditMode}">
    <div v-if="loadingPage" class="load-parent">
      <div class="loader"></div>
    </div>

    <div class="pop-up" :style=" isComponent ? {boxShadow:'none' , padding:'0' } : {}">
      <div v-if="!isComponent" class="head">
        <h4>{{ isEditMode ? 'ویرایش درخواست' : 'درخواست جدید' }}</h4>

      </div>

      <section v-if="isEditMode" class="edit-overview-card">
        <div class="edit-overview-head">
          <div>
            <span class="eyebrow">اطلاعات ثبت درخواست</span>
            <h5>مشخصات ایجادکننده</h5>
          </div>
          <div class="poll-badge" v-if="taskData?.poll !== undefined && taskData?.poll !== null">
            <i class="fa-solid fa-star"></i>
            <span>{{ taskData.poll }}</span>
          </div>
        </div>

        <div class="creator-grid">
          <div class="creator-item">
            <span>نام و نام خانوادگی</span>
            <strong>{{ creator.fullname || '-' }}</strong>
          </div>
          <div class="creator-item">
            <span>شناسه اپراتور</span>
            <strong>{{ creator.opr_number || '-' }}</strong>
          </div>
          <div class="creator-item">
            <span>تاریخ ثبت</span>
            <strong>{{ creator.created_at || '-' }}</strong>
          </div>
          <div class="creator-item">
            <span>نام درگاه</span>
            <strong>{{ creator.cartable_title || '-' }}</strong>
          </div>
        </div>

        <div v-if="audioUrl" class="edit-audio-card">
          <div class="audio-title">
            <i class="fa-regular fa-volume-high"></i>
            <span>فایل صوتی درخواست</span>
          </div>
          <audio id="edit-request-audio" controls>
            <source :src="audioUrl" type="audio/mpeg">
            مرورگر شما از پخش فایل صوتی پشتیبانی نمی‌کند.
          </audio>
          <div class="audio-speeds">
            <span>سرعت پخش</span>
            <button
                v-for="rate in rates"
                :key="rate"
                type="button"
                :class="{ active: selectedRate === rate }"
                @click="changeSpeed(rate)"
            >{{ rate }}x</button>
          </div>
        </div>
      </section>

      <div class="accordion-div" v-if="acc.length > 0">
        <div v-for="(accitem,index) in acc" :key="accitem.id" class="accordion">
          <div @click="accitem.active = !accitem.active" class="head" :class="{'pb-3':!accitem.active}">
            <span>{{ accitem.title }}</span>
            <div v-if="!this.isComponent" class="d-flex btns-top">
              <button v-if="!isEditMode && acc.length > 1" type="button" @click.stop="removeAcc(index)">
                <i class="fa-regular fa-trash"></i>
                حذف
              </button>
              <i class="fa-regular fa-angle-down" :class="{'fa-angle-up':accitem.active}"></i>
            </div>
          </div>

          <div class="form-par" :class="{'active':accitem.active}">

            <form>
              <div class="form mt-5 w-100">
                <div v-if="isVoiceMail" class="sound mr-auto d-flex align-items-center">
                  <v-btn variant="text" class="btn d-flex align-items-center me-2" @click="downloadFile()"><i
                      class="fa fa-download me-2"></i></v-btn>

                  <audio id="audio" controls>
                    <source :src="apiUrl + 'api/voicemails/download/'+dataProp.portalInfo.id" type="audio/mpeg">
                    Your browser does not support the audio element.
                  </audio>

                </div>
                <div class="title d-flex w-100 align-items-center">

                  <button v-if="!isComponent && !isEditMode" @click="contactShow = true ; indexTaskSelected = index"
                          :disabled="disableContact[index].val"
                          type="button" class="btn btn-users"><i
                      class="fa-regular fa-user ml-2"></i>استفاده از مخاطب همخوان
                  </button>
                  <button v-if="!isComponent && !isEditMode" @click="contactAllShow = true ; indexTaskSelected = index"
                          type="button" class="btn btn-users mr-2"><i
                      class="fa-regular fa-user ml-2"></i>همه مخاطبین
                  </button>
                  <button v-if="isComponent2 && !isEditMode" @click="getLastTasksFunc(index)"
                          type="button" class="btn btn-users mr-2"><i
                      class="fa-regular fa-list-check ml-2"></i>انتخاب از تسک های قبلی
                  </button>

                </div>
                <div class="title d-flex w-100 align-items-center">

                  <h5 @click="acc1 = !acc1" class="h5-title w-100 ml-auto  cursor-pointer flex items-center ml-auto">مشخصات
                    مُراجع
                    <span type="button" class="mr-3"><i class="fa-regular"
                                                        :class="acc1 ? 'fa-angle-up':'fa-angle-down'"></i>
                    </span>
                  </h5>

                </div>
                <template v-if="acc1">
                  <div class="input">
                    <label>کد رهگیری</label>
                    <input disabled v-model="forms[index].code" type="text"/>
                  </div>
                  <div class="input">
                    <label>نام </label>
                    <input v-max-length="250" type="text" placeholder="مثال: علی " v-model="forms[index].name"/>
                  </div>
                  <div class="input">
                    <label>نام خانوادگی </label>
                    <input v-max-length="250" type="text" placeholder="مثال: احمدی"
                           v-model="forms[index].family"/>
                  </div>
                  <div class="input">
                    <label>کد ملی</label>
                    <input v-max-length="10" @input="onlyNumber(index);findContact(forms[index].meli_code ,index)"
                           type="text" placeholder="مثال:  0012345679"
                           v-model="forms[index].meli_code"/>
                  </div>
                  <div class="input">
                    <label>شماره ثابت</label>
                    <input v-max-length="12" @input="onlyNumber(index)" type="text" placeholder="مثال:  02122334455"
                           v-model="forms[index].tel"/>
                  </div>
                  <div class="input">
                    <label>شماره موبایل</label>
                    <input @input="onlyNumber(index)"
                           v-max-length="12"
                           @focusout="findContact(forms[index].phone ,index)"
                           type="text" placeholder="مثال: 09121234567"
                           v-model="forms[index].phone"/>
                  </div>

                  <div class="input">
                    <label>استان مبدا تماس</label>
                    <v-autocomplete
                        class="tags-autocomplete"
                        label=""
                        v-model="forms[index].province"
                        :items="provinces"
                        item-title="name"
                        item-value="id"
                        variant="underlined"
                        @update:modelValue="getTasksLocation(index)"
                    ></v-autocomplete>
                  </div>
                  <div class="input">
                    <label>شهر </label>
                    <v-autocomplete
                        class="tags-autocomplete"
                        label=""
                        :disabled="disableCity[index].val"
                        v-model="forms[index].city"
                        :items="cities[index]"
                        item-title="name"
                        item-value="name"
                        variant="underlined"
                        :loading="loading"
                    ></v-autocomplete>
                  </div>
                </template>
              </div>
             <template  v-if="hadafmandi">
               <h5 @click="acc2 = !acc2" class="h5-title w-auto cursor-pointer flex items-center">

                 اطلاعات بانکی
                 <span type="button" class="mr-3">
              <i class="fa-regular"
                 :class="acc2 ? 'fa-angle-up':'fa-angle-down'"></i>
                  </span>
               </h5>
               <div class="form" v-if="acc2">
                 <div
                     v-for="(bank, index) in infoMelliForm?.etelaat_banki"
                     :key="index"
                     class="bank-card"
                 >
                   <div class="bank-card__header">
                     <div class="bank-card__icon">
                       <i class="fa-regular fa-building-columns"></i>
                     </div>

                     <div class="bank-card__heading">
      <span class="bank-card__title">
        اطلاعات حساب بانکی
      </span>

                       <span class="bank-card__number">
        حساب {{ index + 1 }}
      </span>
                     </div>
                   </div>

                   <div class="bank-card__body">
                     <div class="bank-field">
                       <label>
                         <i class="fa-regular fa-building-columns"></i>
                         نام بانک
                       </label>

                       <input
                           disabled
                           type="text"
                           v-model="bank.NAME"
                       />
                     </div>

                     <div class="bank-field">
                       <label>
                         <i class="fa-regular fa-credit-card"></i>
                         شماره حساب
                       </label>

                       <input
                           disabled
                           type="text"
                           v-model="bank.ACCOUNT_NUMBER"
                       />
                     </div>

                     <div class="bank-field">
                       <label>
                         <i class="fa-regular fa-money-check"></i>
                         شماره شبا
                       </label>

                       <input
                           disabled
                           type="text"
                           v-model="bank.IBAN_NUMBER"
                       />
                     </div>
                   </div>
                 </div>

               </div>
               <h5  @click="acc3 = !acc3" class="h5-title w-full px-3 mt-4 mb-3">
                 سوابق پرداخت
                 <span class="cursor-pointer" type="button">
                      <i class="fa-regular"
                         :class="acc3 ? 'fa-angle-up':'fa-angle-down'"></i>
                  </span>
               </h5>
               <div
                   v-show="acc3"
                   v-for="(bank, i) in infoMelliForm?.savabegh_pardakht"
                   :key="i"
                   class="payment-history-card"
               >
                 <div class="payment-history-card__header">
                   <div class="payment-history-card__title">
                     <div class="payment-history-card__icon">
                       <i class="fa-regular fa-money-bill-transfer"></i>
                     </div>

                     <div>
                       <h6>سابقه پرداخت</h6>
                       <span>رکورد {{ i + 1 }}</span>
                     </div>
                   </div>

                   <div class="payment-history-card__amount">
                     <span>مبلغ پرداختی</span>
                     <strong>{{ formatNumber(bank.NET_AMOUNT) || '-' }}</strong>
                   </div>
                 </div>

                 <div class="payment-history-card__body">

                   <div class="payment-field">
                     <label>
                       <i class="fa-regular fa-building-columns"></i>
                       نام بانک
                     </label>

                     <input
                         disabled
                         type="text"
                         v-model="bank.BANK_NAME"
                     />
                   </div>

                   <div class="payment-field">
                     <label>
                       <i class="fa-regular fa-credit-card"></i>
                       شماره حساب
                     </label>

                     <input
                         disabled
                         type="text"
                         v-model="bank.ACCOUNT_NUMBER"
                     />
                   </div>

                   <div class="payment-field">
                     <label>
                       <i class="fa-regular fa-chart-simple"></i>
                       دهک
                     </label>

                     <input
                         disabled
                         type="text"
                         v-model="bank.DECILE_TYPE"
                     />
                   </div>

                   <div class="payment-field">
                     <label>
                       <i class="fa-regular fa-calendar-range"></i>
                       شماره بازه زمانی پرداخت
                     </label>

                     <input
                         disabled
                         type="text"
                         v-model="bank.CREATE_TB"
                     />
                   </div>

                   <div class="payment-field amount-field">
                     <label>
                       <i class="fa-regular fa-calculator"></i>
                       مبلغ محاسبه شده یارانه
                     </label>

                     <input
                         disabled
                         type="text"
                         :value="formatNumber(bank.CR_AMOUNT)"
                     />
                   </div>

                   <div class="payment-field debt-field">
                     <label>
                       <i class="fa-regular fa-circle-exclamation"></i>
                       مبلغ بدهی
                     </label>

                     <input
                         disabled
                         type="text"
                         :value="formatNumber(bank.DB_AMOUNT)"
                     />
                   </div>

                   <div class="payment-field amount-field">
                     <label>
                       <i class="fa-regular fa-calculator"></i>
                       مبلغ محاسبه شده یارانه
                     </label>

                     <input
                         disabled
                         type="text"
                         :value="formatNumber(bank.CR_AMOUNT)"
                     />
                   </div>

                   <div class="payment-field debt-field">
                     <label>
                       <i class="fa-regular fa-circle-exclamation"></i>
                       مبلغ بدهی
                     </label>

                     <input
                         disabled
                         type="text"
                         :value="formatNumber(bank.DB_AMOUNT)"
                     />
                   </div>

                   <div class="payment-field paid-field">
                     <label>
                       <i class="fa-regular fa-circle-check"></i>
                       مبلغ پرداختی یارانه
                     </label>

                     <input
                         disabled
                         type="text"
                         :value="formatNumber(bank.NET_AMOUNT)"
                     />
                   </div>

                 </div>
               </div>
             </template>
              <div ref="addButton" class="btns-add">
                <template v-if="!isEditMode">
                  <div class="tree-box" v-show="showTree">
                    <TreeView2 :nodes="treeData" :initialSelected="accitem?.id"
                               @update-single="(node) => handleSelection2(node, index)"/>
                  </div>
                  <button type="button" @click="showTree = !showTree"><i class="fa-regular fa-folder-plus"></i>
                    {{ accitem.titleButton }}
                  </button>
                </template>
                <div v-else class="locked-request-type">
                  <i class="fa-regular fa-folder-open"></i>
                  <div>
                    <small>گروه درخواست</small>
                    <strong>{{ accitem.title }}</strong>
                  </div>
                  <i class="fa-regular fa-lock lock-icon"></i>
                </div>
              </div>

              <h5 class="h5-title w-full px-3 mt-4 mb-3"  @click="acc4 = !acc4">
                   جزییات تیکت
                <span type="button">
                   <i class="fa-regular"
                      :class="acc4 ? 'fa-angle-up':'fa-angle-down'"></i>
                </span>
              </h5>

              <template v-if="acc4">
                <div
                    v-for="(item) in accitem.forms"
                    :key="item.id"
                    class="dynamic-form-card"
                >
                  <!-- Header -->
                  <div class="dynamic-form-header">
                    <div class="dynamic-form-header__icon">
                      <i class="fa-regular fa-rectangle-list"></i>
                    </div>

                    <div class="dynamic-form-header__content">
                      <h5>{{ item.title }}</h5>
                      <p v-if="item.description">{{ item.description }}</p>
                    </div>
                  </div>

                  <!-- Dynamic fields -->
                  <div class="dynamic-fields-grid">
                    <div
                        v-for="field in item.fields"
                        :key="field.id"
                        class="dynamic-field"
                        :class="{
                          'dynamic-field--full': [
                            'textarea',
                            'checkbox',
                            'radio',
                            'attachment',
                            'new_page',
                            'table'
                          ].includes(field.field_type)
                        }"
                    >
                      <!-- new_page is a visual section separator, not an input -->
                      <div v-if="field.field_type === 'new_page'" class="dynamic-new-page">
                        <div class="dynamic-new-page__icon">
                          <i class="fa-regular fa-file-lines"></i>
                        </div>
                        <div class="dynamic-new-page__content">
                          <h6>{{ field.title }}</h6>
                          <p v-if="field.description">{{ field.description }}</p>
                        </div>
                      </div>

                      <template v-else>
                        <label class="dynamic-field__label">
                          <span>{{ field.title }}</span>

                          <em v-if="isFieldRequired(field)" class="required-mark">*</em>

                          <span
                              v-if="isDynamicFieldDisabled(field)"
                              class="readonly-badge"
                          >
                            <i class="fa-regular fa-lock"></i>
                            فقط خواندنی
                          </span>
                        </label>

                        <p v-if="field.description" class="dynamic-field__description">
                          {{ field.description }}
                        </p>

                        <!-- Checkbox -->
                        <div
                            v-if="field.field_type === 'checkbox'"
                            class="option-group checkbox-group"
                        >
                          <label
                              v-for="(check, optionIndex) in (field.options || [])"
                              :key="`${field.id}-${optionIndex}`"
                              class="option-item"
                              :class="{'option-item--disabled': isDynamicFieldDisabled(field)}"
                          >
                            <input
                                :id="`check-${item.id}-${field.id}-${optionIndex}`"
                                :name="`checkbox-${item.id}-${field.id}`"
                                :value="check.value"
                                v-model="formDataArr[item.id][field.id]"
                                :disabled="isDynamicFieldDisabled(field)"
                                type="checkbox"
                            />

                            <span class="custom-check">
                              <i class="fa-solid fa-check"></i>
                            </span>

                            <span class="option-text">{{ check.value }}</span>
                          </label>
                        </div>

                        <!-- Radio -->
                        <div
                            v-if="field.field_type === 'radio'"
                            class="option-group radio-group"
                        >
                          <label
                              v-for="(radio, radioIndex) in (field.options || [])"
                              :key="`${field.id}-${radio.value}-${radioIndex}`"
                              class="option-item"
                              :class="{'option-item--disabled': isDynamicFieldDisabled(field)}"
                          >
                            <input
                                :id="`radio-${item.id}-${field.id}-${radioIndex}`"
                                :value="radio.value"
                                type="radio"
                                v-model="formDataArr[item.id][field.id]"
                                :disabled="isDynamicFieldDisabled(field)"
                                :name="`radio-${item.id}-${field.id}`"
                            />

                            <span class="custom-radio"></span>
                            <span class="option-text">{{ radio.value }}</span>
                          </label>
                        </div>

                        <!-- Select -->
                        <div
                            v-if="field.field_type === 'single_select' || field.field_type === 'multiple_select'"
                            class="dynamic-select"
                        >
                          <v-autocomplete
                              class="dynamic-autocomplete"
                              label=""
                              v-model="formDataArr[item.id][field.id]"
                              :items="field.options || []"
                              item-title="value"
                              item-value="value"
                              variant="outlined"
                              density="comfortable"
                              hide-details
                              :multiple="field.field_type === 'multiple_select'"
                              :disabled="isDynamicFieldDisabled(field)"
                          />
                        </div>

                        <!-- Text / Number -->
                        <input
                            v-if="field.field_type === 'text' || field.field_type === 'number'"
                            v-max-length="250"
                            class="dynamic-input"
                            v-model="formDataArr[item.id][field.id]"
                            :disabled="isDynamicFieldDisabled(field)"
                            :placeholder="field.placeholder || field.description || ''"
                            :type="field.field_type === 'text' ? 'text' : 'number'"
                        />

                        <!-- Date -->
                        <div v-if="field.field_type === 'date'" class="dynamic-date">
                          <date-picker
                              class="input-date"
                              placeholder="تاریخ"
                              @selected="getDate(item.id, field.id, $event)"
                              v-model="formDataArr[item.id][field.id]"
                              :disabled="isDynamicFieldDisabled(field)"
                              :value="formDataArr[item.id][field.id]"
                          />
                        </div>

                        <!-- Textarea -->
                        <textarea
                            v-if="field.field_type === 'textarea'"
                            class="dynamic-textarea"
                            v-model="formDataArr[item.id][field.id]"
                            :disabled="isDynamicFieldDisabled(field)"
                            :placeholder="field.placeholder || field.description || ''"
                        ></textarea>

                        <!-- Attachment -->
                        <div
                            v-if="field.field_type === 'attachment'"
                            class="dynamic-attachment"
                            :class="{'is-disabled': isDynamicFieldDisabled(field)}"
                        >
                          <input
                              :id="`dynamic-file-${item.id}-${field.id}`"
                              class="dynamic-attachment__input"
                              type="file"
                              :multiple="field.multiple === true || field.multiple === 1 || field.multiple === '1'"
                              :disabled="isDynamicFieldDisabled(field)"
                              @change="handleDynamicFieldFiles(item.id, field, $event)"
                          />

                          <label
                              :for="`dynamic-file-${item.id}-${field.id}`"
                              class="dynamic-attachment__dropzone"
                          >
                            <span class="dynamic-attachment__icon">
                              <i class="fa-regular fa-cloud-arrow-up"></i>
                            </span>
                            <span class="dynamic-attachment__texts">
                              <strong>انتخاب فایل</strong>
                              <small>برای انتخاب فایل کلیک کنید</small>
                            </span>
                          </label>

                          <div
                              v-if="getExistingDynamicAttachments(item.id, field.id).length || getDynamicFieldFiles(item.id, field.id).length"
                              class="dynamic-attachment__list"
                          >
                            <div
                                v-for="(existingFile, existingIndex) in getExistingDynamicAttachments(item.id, field.id)"
                                :key="`existing-${item.id}-${field.id}-${existingIndex}`"
                                class="dynamic-attachment__file existing"
                            >
                              <i class="fa-regular fa-paperclip"></i>
                              <span>{{ getDynamicAttachmentDisplayName(existingFile) }}</span>
                              <small>فایل قبلی</small>
                            </div>

                            <div
                                v-for="(selectedFile, selectedIndex) in getDynamicFieldFiles(item.id, field.id)"
                                :key="`selected-${item.id}-${field.id}-${selectedIndex}`"
                                class="dynamic-attachment__file"
                            >
                              <i class="fa-regular fa-file"></i>
                              <div>
                                <span>{{ selectedFile.name }}</span>
                                <small>{{ formatDynamicFileSize(selectedFile.size) }}</small>
                              </div>
                              <button
                                  type="button"
                                  :disabled="isDynamicFieldDisabled(field)"
                                  @click="removeDynamicFieldFile(item.id, field.id, selectedIndex)"
                              >
                                <i class="fa-regular fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Table -->
                        <div v-if="field.field_type === 'table'" class="dynamic-table-section">
                          <div class="dynamic-table-scroll">
                            <table class="dynamic-data-table">
                              <thead>
                              <tr>
                                <th
                                    v-for="column in (field.options || [])"
                                    :key="column.key || column.name"
                                >
                                  {{ column.name || column.key }}
                                  <em v-if="isTruthyFlag(column.required)" class="required-mark">*</em>
                                </th>
                                <th class="dynamic-table-actions"></th>
                              </tr>
                              </thead>

                              <tbody>
                              <tr
                                  v-for="(row, rowIndex) in getTableRows(item.id, field.id)"
                                  :key="`${field.id}-row-${rowIndex}`"
                              >
                                <td
                                    v-for="column in (field.options || [])"
                                    :key="`${field.id}-${rowIndex}-${column.key || column.name}`"
                                >
                                  <select
                                      v-if="['single_select', 'select'].includes(column.type)"
                                      v-model="row[column.key || column.name]"
                                      class="dynamic-table-input"
                                      :disabled="isDynamicFieldDisabled(field) || isTruthyFlag(column.readonly)"
                                  >
                                    <option value="">انتخاب کنید</option>
                                    <option
                                        v-for="(option, optionIndex) in (column.options || [])"
                                        :key="optionIndex"
                                        :value="typeof option === 'object' ? option.value : option"
                                    >
                                      {{ typeof option === 'object' ? option.value : option }}
                                    </option>
                                  </select>

                                  <input
                                      v-else
                                      v-model="row[column.key || column.name]"
                                      class="dynamic-table-input"
                                      :type="getTableInputType(column.type)"
                                      :disabled="isDynamicFieldDisabled(field) || isTruthyFlag(column.readonly)"
                                  />
                                </td>

                                <td class="dynamic-table-actions">
                                  <button
                                      type="button"
                                      class="dynamic-table-remove"
                                      title="حذف ردیف"
                                      :disabled="isDynamicFieldDisabled(field)"
                                      @click="removeDynamicTableRow(item.id, field.id, rowIndex)"
                                  >
                                    <i class="fa-regular fa-trash"></i>
                                  </button>
                                </td>
                              </tr>

                              <tr v-if="getTableRows(item.id, field.id).length === 0">
                                <td :colspan="(field.options || []).length + 1" class="dynamic-table-empty">
                                  هنوز ردیفی ثبت نشده است.
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>

                          <button
                              type="button"
                              class="dynamic-table-add"
                              :disabled="isDynamicFieldDisabled(field)"
                              @click="addDynamicTableRow(item.id, field)"
                          >
                            <i class="fa-regular fa-plus"></i>
                            افزودن ردیف
                          </button>
                        </div>

                        <!-- Unknown field type fallback -->
                        <div
                            v-if="!supportedDynamicFieldTypes.includes(field.field_type)"
                            class="dynamic-unsupported-field"
                        >
                          <i class="fa-regular fa-triangle-exclamation"></i>
                          نوع فیلد «{{ field.field_type }}» هنوز در رابط کاربری تعریف نشده است.
                        </div>
                      </template>
                    </div>
                  </div>
                </div>

                <div class="form mt-5 w-100">

                  <div class="input w-100">
                    <label>تگ ها</label>
                    <v-autocomplete
                        class="tags-autocomplete"
                        label=""
                        v-model="forms[index].tags"
                        :items="tags"
                        item-title="title"
                        item-value="id"
                        multiple
                        variant="underlined"
                    ></v-autocomplete>
                  </div>
                  <div class="input">
                    <label>میزان اهمیت</label>
                    <v-autocomplete
                        class="tags-autocomplete"
                        label=""
                        v-model="forms[index].level"
                        :items="levels"
                        item-title="name"
                        item-value="index"
                        variant="underlined"
                    ></v-autocomplete>
                  </div>
                  <div class="input">
                    <label>باز/بسته</label>
                    <v-autocomplete
                        class="tags-autocomplete"
                        label=""
                        v-model="forms[index].is_closed"
                        :items="['باز','بسته']"

                        item-title="name"
                        item-value="index"
                        variant="underlined"
                    ></v-autocomplete>
                  </div>
                  <div class="input">
                    <label>وضعیت</label>
                    <v-autocomplete
                        class="tags-autocomplete"
                        label=""
                        v-model="forms[index].status_id"
                        :items="statuses"
                        item-title="title"
                        item-value="id"
                        variant="underlined"
                    ></v-autocomplete>
                  </div>
                </div>


                <div class="attachments">

                  <div class="right-box mb-4">
                    <h6 class="mb-2">فایل ضمیمه</h6>
                    <div v-if="isEditMode && previousAttachments.length" class="previous-attachments">
                      <div v-for="(file,f) in previousAttachments" :key="`previous-${f}`" class="attach previous-attach">
                        <i class="fa-regular fa-paperclip"></i>
                        <span>{{ file?.name || file?.file_name || file?.file_path }}</span>
                        <v-btn type="button" variant="text" :loading="file.loading" @click="downloadAttach(file)"
                               class="btn btn-download mr-auto">
                          دانلود <i class="fa-regular fa-cloud-download"></i>
                        </v-btn>
                      </div>
                    </div>
                    <div v-for="(file,f) in attachment[index]" :key="f" class="attach">
                      <i class="fa-regular fa-paperclip"></i>
                      <span v-if="!isComponent">{{ file?.name || file?.file_name }}</span>
                      <span v-if="isComponent">{{ file?.file_path || file?.file_name || file?.name }}</span>
                      <button v-if="!isComponent" @click="removeAttach(index,f)" type="button"
                              class="fa-regular fa-trash"></button>
                      <v-btn :loading="file.loading" v-if="isComponent" @click="downloadAttach(file)"
                             class="btn btn-download">
                        دانلود <i class="fa-regular fa-cloud-download"></i></v-btn>
                    </div>


                    <!--                  <button class="btn-upload">
                                        <input type="file" accept="image/*,application/pdf"
                                               multiple

                                               @change="handleFileUpload(index)">
                                        <i class="fa-regular fa-"></i> آپلود فایل
                                      </button>-->

                    <v-btn
                        variant="text"
                        class="btn-upload w-100 h-auto"
                        @click="attachInfoModal = true"
                        :class="uploadStore.isBlocked ? 'disabled' :''"
                        :disabled="uploadStore.isBlocked"
                    >
                      <i class="fa-light fa-paperclip"></i>
                      <span v-if="uploadStore.isBlocked">    آپلود فایل {{ uploadStore.remainingText }}</span>
                      <span v-else>آپلود فایل</span>
                    </v-btn>

                    <v-dialog v-model="attachInfoModal" max-width="550">
                      <v-card class="excel-upload-modal">
                        <v-card-text class="pa-8 text-center">

                          <div class="excel-icon">
                            <i class="fa-light fa-paperclip"></i>
                          </div>

                          <h2 class="mt-4 mb-2">آپلود فایل ضمیمه</h2>

                          <p class="text-grey-darken-1 mb-6">
                            لطفاً قبل از انتخاب فایل، محدودیت‌های زیر را مطالعه کنید.
                          </p>

                          <div class="upload-rules">
                            <div class="rule-item">
                              <i class="fa-light fa-file-check"></i>
                              <span>فرمت‌های مجاز: Image ، Pdf  </span>
                            </div>

                            <div class="rule-item">
                              <i class="fa-light fa-hard-drive"></i>
                              <span>حداکثر حجم فایل: 1 مگابایت</span>
                            </div>

                          </div>
                          <div class="validation-list my-6">
                            <div v-for="(item, i) in validationFiles" :key="i"
                                 class="file-item d-flex align-center pa-3 mb-3 rounded-lg"
                                 :class="{ 'valid-file': item.isValid, 'invalid-file': !item.isValid }">

                              <!-- Preview -->
                              <div v-if="item.preview" class="mr-4 flex-shrink-0">
                                <img :src="item.preview"
                                     style="width: 52px; height: 52px; object-fit: cover; border-radius: 6px;">
                              </div>
                              <div v-else class="mr-4 flex-shrink-0">
                                <i class="fa-light fa-file" style="font-size: 42px; color: #666;"></i>
                              </div>

                              <!-- اطلاعات فایل -->
                              <div class="flex-grow-1">
                                <div class="font-weight-medium ">{{ item.name }}</div>
                                <div class="text-grey-darken-1">{{ item.size }}</div>

                                <div v-if="item.errors.length" class="mt-1 red--text font-weight-medium">
                                  {{ item.errors.join("، ") }}
                                </div>
                              </div>


                              <v-btn
                                  v-if="!item.isValid"
                                  icon
                                  color="red"
                                  @click="removeValidationFile(i)"
                              >
                                <i class="fa fa-close"></i>
                              </v-btn>
                            </div>
                          </div>

                        </v-card-text>

                        <v-divider/>

                        <v-card-actions class="pa-4">
                          <v-spacer/>

                          <v-btn
                              variant="text"
                              color="grey"
                              @click="attachInfoModal = false"
                          >
                            انصراف
                          </v-btn>

                          <v-btn
                              @click="selectAttach(index)"
                              class="add-btn-attach"
                          >
                            انتخاب فایل
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <input
                        ref="attachInputs"
                        type="file"
                        multiple
                        style="display:none"
                        accept="image/*,application/pdf"
                        @change="handleFileUpload(index, $event)"
                    />

                  </div>

                  <section class="national-history w-100">
                    <button type="button" class="national-history__toggle"
                            :aria-expanded="Boolean(historyByCode[forms[index].meli_code]?.open)"
                            @click="showMelli(index)">
                      <span>نمایش تاریخچه بر اساس کد ملی</span>
                      <i class="fa-regular" aria-hidden="true"
                         :class="historyByCode[forms[index].meli_code]?.open ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>
                    <div v-if="historyByCode[forms[index].meli_code]?.open" class="national-history__body">
                      <p v-if="historyByCode[forms[index].meli_code].loading" role="status">در حال دریافت تاریخچه...</p>
                      <div v-else-if="historyByCode[forms[index].meli_code].error" role="alert">
                        <p>دریافت تاریخچه با خطا مواجه شد.</p>
                        <button type="button" @click="showMelli(index, true)">تلاش مجدد</button>
                      </div>
                      <TasksList v-else-if="historyByCode[forms[index].meli_code].items.length"
                                 :key="forms[index].meli_code"
                                 :data="historyByCode[forms[index].meli_code].items"/>
                      <p v-else role="status">برای این کد ملی سابقه‌ای ثبت نشده است.</p>
                    </div>
                  </section>
                  <div class="faq-section-title mt-5 mb-3 w-100">
                    <div>
                      <i class="fa-regular fa-circle-question"></i>
                      <span>پرسش‌های پرتکرار</span>
                    </div>
                    <small>با انتخاب هر پاسخ، متن آن در بخش پاسخ قرار می‌گیرد.</small>
                  </div>
                  <div class="row w-100 faq-response-row">
                    <div class="col-md-6">
                      <div v-if="faqs.length > 0" class="faq-list">
                        <!-- Search Box -->
                        <div class="faq-search">
                          <div class="search-input-wrapper">
                            <i class="fa-regular fa-magnifying-glass"></i>
                            <input
                                type="text"
                                v-model="searchQuery"
                                placeholder="جستجو در سوالات..."
                                class="faq-search-input"
                            />
                            <button
                                v-if="searchQuery"
                                type="button"
                                class="clear-search"
                                @click="searchQuery = ''"
                                title="پاک کردن"
                            >
                              <i class="fa-regular fa-xmark"></i>
                            </button>
                          </div>
                        </div>

                        <!-- FAQ Items -->
                        <article
                            v-for="item in filteredFaqs"
                            :key="item.id"
                            class="faq-item"
                            :class="{ active: item.active }"
                        >
                          <div class="faq-question-row">
                            <label class="faq-select" :for="`faq-${index}-${item.id}`" title="استفاده از این پاسخ">
                              <input
                                  type="checkbox"
                                  :checked="forms[index].answer === item.answer"
                                  @change="selectFaq(item, index)"
                                  :id="`faq-${index}-${item.id}`"
                              >
                              <span><i class="fa-regular fa-check"></i></span>
                            </label>
                            <button type="button" @click="accToggle(item)" class="faq-toggle">
                              <span>{{ item.question }}</span>
                              <i class="fa-regular fa-angle-down" :class="{ rotated: item.active }"></i>
                            </button>
                          </div>
                          <div v-show="item.active" class="faq-answer">
                            <p>{{ item.answer }}</p>
                          </div>
                        </article>

                        <!-- Empty state وقتی چیزی پیدا نشد -->
                        <div v-if="filteredFaqs.length === 0" class="faq-empty">
                          نتیجه‌ای یافت نشد
                        </div>
                      </div>
                      <div v-else class="faq-empty">
                        <i class="fa-regular fa-circle-question"></i>
                        <span>برای این گروه درخواست پرسش پرتکراری ثبت نشده است.</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="left-box w-100 p-0">
                        <div class="label mb-2 d-flex align-items-center">
                          <h6 class="mb-0 ml-auto"> توضیحات</h6>
                          <v-btn v-if="!isComponent && aiAccess" style="box-shadow: none;"
                                 :loading="loadingAiModule"
                                 type="button"
                                 @click="getAiModule(index)" class=" btn btn-ai-response">استعلام از دیگر سامانه ها
                          </v-btn>
                          <v-btn v-if="!isComponent && aiAccess" style="box-shadow: none;"
                                 :loading="loadingAi" type="button"
                                 @click="getAi(index)"
                                 class="mr-2 btn btn-ai-response">پاسخ هوش مصنوعی
                          </v-btn>

                        </div>
                        <textarea v-max-length="500" v-model="forms[index].description"></textarea>
                      </div>
                      <div class="left-box w-100 pt-2">
                        <h6 class="mb-2 d-flex align-items-center">
                          <span>پاسخ</span>
                          <button v-if="isVoiceMail || (isEditMode && taskInfo?.task?.cartable_id === 2)" type="button" @click="recordeVoiceFunc(index)"
                                  class="mr-auto btn btn-ai-response">ضبط پاسخ صوتی
                          </button>
                        </h6>
                        <textarea v-max-length="500" v-model="forms[index].answer"></textarea>
                      </div>
                      <div class="left-box w-100 pt-2">
                        <h6 class="mb-2"> یادداشت</h6>
                        <textarea v-max-length="500" v-model="forms[index].note"></textarea>
                      </div>

                    </div>
                  </div>

                  <RequestActivityTimeline :answers="answers" :notes="notes" />

                </div>
              </template>


              <div class="btns-bottom">

                <v-btn :class="{ 'custom-active': hadafmandi }" :disabled="taskAddedSuccessful[index] || loading"
                       @click="ShowTransmissionModal(index)"
                       class="btn-transmission mt-4 mb-5"><i
                    class="fa-light fa-users"></i>ذخیره وانتقال
                </v-btn>
                <v-btn :class="{ 'custom-active': hadafmandi }" :disabled="taskAddedSuccessful[index]"
                       :loading="loading"
                       @click="submitRequest(index)" class="btn-save mt-1 mb-5">
                  <i class="fa-light fa-floppy-disk"></i>
                  {{ taskAddedSuccessful[index] ? 'با موفقیت ثبت شد' : (isEditMode ? 'ذخیره تغییرات' : 'ذخیره') }}
                </v-btn>
              </div>


            </form>
          </div>

        </div>
      </div>

      <div v-if="!isComponent && !isComponent2 && !isEditMode" class="col-12 px-2">
        <div @click="addNewAcc" class="add-new-button">
          <span><i class="fa-regular fa-plus"></i>افزودن </span>
        </div>
      </div>

      <div v-if="Object.keys(errors).length > 0" class="alert w-100 alert-danger mt-3 mb-0" role="alert">
        <div v-for="(err,index) in errors" :key="index">
          <span v-for="(msg,i) in err" :key="i">{{ index }} : {{ msg }}</span>
        </div>
      </div>

    </div>

    <v-dialog
        class="remove-dialog"
        v-model="confirmChangeContact"
        max-width="600"
        persistent
    >

      <v-card
          text=""
          title=""
      >
        <template v-slot:actions>

          <div>
            <button></button>
            <span class="text-right p-0 px-4 d-block">در اطلاعات مخاطب تغییری داده شده است، میخواهید به عنوان مخاطب جدید درج شود؟ یا
              مخاطب فعلی ویرایش شود ؟</span>
            <v-spacer></v-spacer>
            <div class="btns mt-4">
              <v-btn class="px-2" @click="editContact = 1;submitRequest(indexTaskSelected,false)">
                مخاطب فعلی ویرایش شود
              </v-btn>

              <v-btn class="px-2" :loading="loading" @click=" editContact = 2;submitRequest(indexTaskSelected,false)">
                درج به عنوان مخاطب جدید
              </v-btn>
            </div>
          </div>

        </template>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="transmissionModal"
        class="dialog-transmission"
        width="740px"
    >
      <div class="box-modal">
        <div class="top mb-2">
          <h5>انتقال درخواست</h5>
          <i @click="transmissionModal = false" class="fa-regular fa-close"></i>
        </div>

        <div class="forms">

          <div class="input">
            <label>انتخاب دپارتمان</label>
            <v-autocomplete
                class="tags-autocomplete"
                label=""
                item-title="title"
                item-value="id"
                v-model="departmentsModel[indexTaskSelected].id"
                :items="departmentItems"
                variant="underlined"
            ></v-autocomplete>
          </div>
          <div class="input">
            <label>انتخاب کارشناس</label>
            <v-autocomplete
                class="tags-autocomplete"
                label=""
                item-title="name"
                item-value="id"
                v-model="departmentsModel[indexTaskSelected].user"
                :items="departmentUsers"
                variant="underlined"
                :disabled="this.userInfo.department_id !== departmentsModel[indexTaskSelected].id"

            ></v-autocomplete>
          </div>

          <v-btn :loading="loading" @click="submitRequest(indexTaskSelected,true)" class="btn-save mt-4 mb-5"><i
              class="fa-light fa-users"></i>تکمیل انتقال
          </v-btn>

        </div>
      </div>
    </v-dialog>
    <v-dialog
        v-model="contactShow"
        class="dialog-contact"
        width="740px"
    >
      <div class="box-modal">
        <div class="top mb-2">
          <h5>لیست مخاطبین</h5>
          <i @click="contactShow = false" class="fa-regular fa-close"></i>
        </div>
        <div class="input w-100">
          <label class="mt-2 mb-1">مخاطبین</label>
          <v-autocomplete
              class="tags-autocomplete"
              label=""
              v-model="forms[indexTaskSelected].contactId"
              :items="contacts[indexTaskSelected]"
              item-title="name"
              item-value="id"
              variant="underlined"
              :loading="loadingContact"
          ></v-autocomplete>
        </div>
        <btn :class="{ 'custom-active': hadafmandi }" class="btn btn-save" @click="setContactInfo(forms[indexTaskSelected].contactId , indexTaskSelected)">
          ذخیره
        </btn>


      </div>
    </v-dialog>
    <v-dialog
        v-model="contactAllShow"
        class="dialog-contact"
        width="740px"
    >
      <div class="box-modal contact-all-list">
        <div class="top mb-2">
          <h5>لیست همه مخاطبین</h5>
          <i @click="contactAllShow = false" class="fa-regular fa-close"></i>
        </div>
        <div class="head-table">
          <div class="right">
            <v-btn @click="filterShow = !filterShow" :class="{'active':filterShow}" variant="text" class="btn-filter">
              <i class="fa-light fa-filter"></i>
              <span class="text">فیلتر</span>
            </v-btn>
          </div>
        </div>
        <div v-if="filterShow" class="filter-row">
          <div class="input">
            <input type="text" placeholder="نام " v-model="filterVals.name"
                   @input="debouncedSearch('نام' ,'name')"
            >
          </div>
          <div class="input">
            <input type="text" placeholder="نام خانوادگی" v-model="filterVals.family"
                   @input="debouncedSearch('نام خانوادگی' ,'family')"
            >
          </div>
          <div class="input">
            <input type="text" placeholder="شماره همراه" v-model="filterVals.phone"
                   @input="debouncedSearch('شماره همراه' ,'phone')"
            >
          </div>


        </div>
        <div v-if="filterShow" class="tags">
          <div class="tag" v-for="(tag, index) in tagsFilter" :key="index">
            <em>{{ tag.title }}</em>:{{ tag.valueTitle }}
            <i class="fa-regular fa-close" @click="removeTag(index ,tag.name)"></i>
          </div>
        </div>

        <div class="table-section">
          <div v-if="loadingPage" class="load-parent">
            <div class="loader"></div>
          </div>
          <table v-if="contactsAll?.data?.length > 0" class="table table-striped">
            <thead>
            <tr>
              <th scope="col"> شناسه</th>
              <td>نام و نام خانوادگی</td>
              <td>تلفن</td>
              <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in contactsAll.data" :key="item.id">
              <th>{{ item.id }}</th>
              <td>{{ item.name }} {{ item.family }}</td>
              <td>{{ item?.phones?.mobile }}</td>
              <td>
                <button :class="{ 'custom-active': hadafmandi }" @click="setContactInfo2(item)" class="add-contact">افزودن</button>
              </td>
            </tr>


            </tbody>
          </table>
          <h1 v-else class="no-find">هیچ موردی یافت نشد!</h1>
        </div>

      </div>
    </v-dialog>
    <v-dialog
        v-model="tasksAllShow"
        class="dialog-contact"
        width="740px"
    >
      <div class="box-modal contact-all-list">
        <div class="top mb-2">
          <h5>لیست تسک ها</h5>
          <i @click="tasksAllShow = false" class="fa-regular fa-close"></i>
        </div>

        <div class="filter-row">
          <div class="input w-50 position-relative">

            <v-text-field label="" v-model="taskIdSearch" :disabled="loadingSearch" :loading="loadingSearch"
                          placeholder="جستجوی شناسه ... " variant="underlined"></v-text-field>
          </div>


        </div>


        <div class="table-section">
          <div v-if="loadingPage" class="load-parent">
            <div class="loader"></div>
          </div>
          <table v-if="lastTasks?.length > 0" class="table table-striped">
            <thead>
            <tr>
              <th scope="col"> شناسه</th>
              <td>استان</td>
              <td>شهر</td>
              <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in lastTasks" :key="item.id">
              <th>{{ item.id }}</th>
              <td>{{ item.province }} {{ item.family }}</td>
              <td>{{ item.city }}</td>
              <td>
                <v-btn :class="{ 'custom-active': hadafmandi }" :loading="item.taskEditLoading" @click="getTaskInfo(item)" class="add-contact">انتخاب</v-btn>
              </td>
            </tr>


            </tbody>
          </table>
          <h1 v-else class="no-find">هیچ موردی یافت نشد!</h1>
        </div>

      </div>
    </v-dialog>
    <v-dialog
        v-model="aiShow"
        class="dialog-ai"
        width="800px"
        aria-labelledby="ai-response-title"
    >
      <div class="ai-response-modal" dir="rtl">
        <header class="ai-response-header">
          <span class="ai-response-icon"><i class="fa-solid fa-robot" aria-hidden="true"></i></span>
          <div>
            <h5 id="ai-response-title">پاسخ هوش مصنوعی</h5>
            <p>پاسخ پیشنهادی بر اساس اطلاعات درخواست شما</p>
          </div>
          <v-btn icon variant="text" size="small" aria-label="بستن پنجره" @click="aiShow = false">
            <i class="fa-regular fa-close" aria-hidden="true"></i>
          </v-btn>
        </header>
        <div class="ai-response-body">
          <section v-if="aiResponse?.input_text" class="ai-request-context">
            <h6>توضیحات درخواست</h6>
            <p>{{ aiResponse.input_text }}</p>
          </section>
          <section v-if="hasAiSuggestion" class="ai-suggestion">
            <h6><i class="fa-regular fa-comment" aria-hidden="true"></i> پاسخ پیشنهادی</h6>
            <div class="ai-suggestion-content" v-html="aiResponse.suggestion"></div>
          </section>
          <p v-else class="ai-response-empty" role="status">{{ aiResponse?.message || 'پاسخی برای این درخواست یافت نشد.' }}</p>
          <section v-if="aiSources.length" class="ai-sources">
            <h6><i class="fa-regular fa-file-lines" aria-hidden="true"></i> منابع:</h6>
            <ol class="ai-source-list">
              <li v-for="(source, index) in aiSources" :key="index">
                <span class="ai-source-number">{{ (index + 1).toLocaleString('fa-IR') }}</span>
                <span class="ai-source-text" dir="auto">{{ source }}</span>
              </li>
            </ol>
          </section>
        </div>
        <footer class="ai-response-footer">
          <v-btn variant="outlined" class="ai-dismiss" @click="aiShow = false">
            انصراف
          </v-btn>
          <v-btn v-if="hasAiSuggestion" color="primary" variant="flat"
                 @click="userAiResponse()" class="ai-use-response">
            استفاده از پاسخ
          </v-btn>
        </footer>
      </div>
    </v-dialog>
    <v-dialog
        v-model="aiModuleShow"
        class="dialog-ai"
        width="740px"
    >
      <div class="box-modal">
        <div class="top mb-2">
          <h5>لیست دیگر سامانه ها</h5>
          <i @click="aiModuleShow = false" class="fa-regular fa-close"></i>
        </div>
        <div class="list-text-data">
          <span v-for="item in aiModuleResponse" :key="item.id">{{ item.text_data }}</span>

        </div>


        <div class="d-flex align-items-center justify-content-end w-100">
          <v-btn class="btn btn-cancel" @click="aiModuleShow = false">
            بستن
          </v-btn>


        </div>


      </div>
    </v-dialog>
    <v-dialog
        v-model="voiceRecorderModal"
        class="dialog-ai"
        width="500px"
    >
      <div class="box-modal">
        <div class="top mb-2">
          <h5>ضبط صدا</h5>
          <i @click="voiceRecorderModal = false" class="fa-regular fa-close"></i>
        </div>

        <div class="w-100 my-3">
          <AudioRecorder :file="this.forms[this.indexTaskSelected].answer_attachments" @audioSelected="submitAudio"/>
        </div>


      </div>
    </v-dialog>
    <v-snackbar
        :timeout="3000"
        v-model="snackbar"
        :color="colorSnack"
    >
      {{ textSnack }}

      <template v-slot:actions>
        <v-btn

            variant="tonal"
            @click="snackbar = false"
        >
          <i class="fa-regular fa-close"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import RequestActivityTimeline from "@/components/RequestActivityTimeline.vue";
import axios from "@/plugins/axios.js";
import store from "@/store";
import datePicker from "@/components/Calendar";
import TasksList from "@/views/management/TasksList.vue";
import moment from "moment-jalaali";
import {defineAsyncComponent} from "vue";
import AudioRecorder from "@/components/AudioRecorder";
import {useUserStore} from "@/store/user";
import {useUploadBlockStore} from "@/store/uploadBlock";

export default {
  name: "RequestView",
  components: {
    RequestActivityTimeline,
    AudioRecorder, TreeView2: defineAsyncComponent(() =>
        import('@/components/TreeView2.vue')
    ), datePicker, TasksList
  },
  props: {
    isComponent: {
      type: Boolean,
      default: false,
      required: false
    },
    isVoiceMail: {
      type: Boolean,
      default: false,
      required: false
    },
    isComponent2: {
      type: Boolean,
      default: false,
      required: false
    },
    dataProp: {
      type: Object,
      required: false

    },
    typeId: {
      type: Number,
      default: 0,
      required: false
    },
    typeTitle: {
      type: String,
      default: '',
      required: false
    },
    eventData: {
      type: Object,
      default: () => ({}),
      required: false
    },
    mode: {
      type: String,
      default: 'create',
      validator: (value) => ['create', 'edit'].includes(value)
    },
    taskInfo: {
      type: Object,
      default: null,
      required: false
    },


  },
  data() {
    return {
      apiUrl: store.getters.baseUrl,
      apiBaseUrl: window.appConfig.API_URL_BASE,
      hadafmandi: window.appConfig.hadafmandi,
      selectedRate: 1,
      rates: [0.5, 1, 1.5, 2],
      editHydrated: false,
      searchQuery: '',
      historyByCode: {},
      showTree: false,
      taskData: {},
      contactData: {},
      previousAttachments: [],
      audioUrl: '',
      creator: {
        fullname: '',
        opr_number: '',
        created_at: '',
        cartable_title: ''
      },
      faqs: [],
      infoMelli: {},
      loadingMelli: false,
      confirmMelli: false,
      first: false,
      acc1: true,
      acc2: true,
      acc3: true,
      acc4: true,
      infoMelliForm: {
        sarparast_khanvar: {
          FATHER_NAME: ''
        },
        etelaat_banki: [{
          ACCOUNT_NUMBER: '',
          IBAN_NUMBER: '',
          NAME: '',
        }],
        address: '',
        shomare_tamas: '',
        vaziat_yarane: '',
        vaziat_kalabarg: '',
        tedad_aaza_khanvar: '',
        dehk_khanvar: ''
      },
      confirmChangeContact: false,
      snackbar: false,
      contactShow: false,
      contactAllShow: false,
      tasksAllShow: false,
      filterShow: false,
      loadingSearch: false,
      voiceRecorderModal: false,
      textSnack: '',
      filterName: '',
      colorSnack: '',
      taskIdSearch: '',
      loading: false,
      loadingAi: false,
      loadingAiModule: false,
      editContact: 0,
      aiModuleShow: false,
      errors: {},
      loadingContact: false,
      selectedNode: null,
      loadingPage: false,
      attachInfoModal: false,
      perPage: 20,
      treeData: [],
      contactsAll: [],
      checkboxesModel: [],
      lastTasks: [],
      answers: [],
      notes: [],
      tags: "",
      tagsFilter: [],
      timeout: null,
      transmissionModal: false,
      cartable_id: 1,
      aiShow: false,
      aiResponse: '',
      aiModuleResponse: [],
      acc: [],
      provinces: [],
      contacts: [],
      cities: [],
      filterVals: {
        name: '',
        family: '',
        phone: '',
      },
      aiAccess: false,
      disableCity: Array.from({length: 20}, () => ({
        val: true
      })),
      disableContact: Array.from({length: 20}, () => ({
        val: true
      })),
      taskAddedSuccessful: Array.from({length: 20}, () => ({
        val: false
      })),

      deparments: [],
      departmentUsers: [],
      levels: [],
      nodeId: '',
      uploadStore: '',
      formDataArr: {},
      dynamicFieldFiles: {},
      supportedDynamicFieldTypes: ['text', 'number', 'checkbox', 'radio', 'single_select', 'multiple_select', 'date', 'textarea', 'attachment', 'new_page', 'table'],
      departmentsModel: Array.from({length: 20}, () => ({
        id: '',
        user: '',
      })),
      contactSelected: '',
      related: Array.from({length: 20}, () => false),
      forms: Array.from({length: 20}, () => ({
        code: '',
        type_id: '',
        name: '',
        family: '',
        meli_code: '',
        tel: '',
        phone: this.eventData.callerid,
        province: '',
        city: '',
        tags: '',
        contactId: '',
        description: '',
        level: 0,
        status_id: '',
        note: '',
        answer: '',
        fileds: '',
        is_closed: 'بسته',
        answer_attachments: '',

      })),
      attachment: [],
      files: Array.from({length: 20}),
      fields: [],
      validationFiles: [],
      statuses: [],
      userInfo: {},
      indexTaskSelected: '',
      headers: {
        'Accept': 'Application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
  },
  computed: {
    hasAiSuggestion() {
      return typeof this.aiResponse?.suggestion === 'string' && this.aiResponse.suggestion.trim().length > 0
    },
    aiSources() {
      const formatSource = value => {
        if (value === null || value === undefined) return ''
        if (Array.isArray(value)) return value.map(formatSource).filter(Boolean).join('\n')
        if (typeof value === 'object') {
          return Object.entries(value)
              .map(([key, entry]) => {
                const text = formatSource(entry)
                return text ? `${key}: ${text}` : ''
              })
              .filter(Boolean).join('\n')
        }
        return String(value).trim()
      }
      const source = this.aiResponse?.source
      return (Array.isArray(source) ? source : [source]).map(formatSource).filter(Boolean)
    },
    filteredFaqs() {
      if (!this.searchQuery.trim()) {
        return this.faqs;
      }
      const query = this.searchQuery.trim().toLowerCase();
      return this.faqs.filter(item =>
          item.question.toLowerCase().includes(query)
      );
    },
    userData() {
      return useUserStore().getUserInfo
    },
    isEditMode() {
      return this.mode === 'edit' || !!this.taskInfo
    },
    isCreateMode() {
      return !this.isEditMode
    },
    departmentItems() {
      if (Array.isArray(this.deparments)) return this.deparments
      if (Array.isArray(this.deparments?.data)) return this.deparments.data
      return []
    }
  },
  watch: {
    'forms.0.type_id'(newVal) {
      if (newVal) this.getFaqs(newVal)
    },
    taskInfo: {
      handler(val) {
        if (this.isEditMode && val) {
          this.hydrateEditMode(val)
        }
      },
      deep: true
    },
    taskIdSearch(val) {

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {

        this.getLastTasks(val)

      }, 1000);

    },
    isComponent2: {
      handler() {
        console.log('021')

      },
      deep: true
    },
    tagsFilter: {
      handler() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.getContacts(true)

        }, 1000);

      },
      deep: true
    },
    updateMode(val) {
      if (!val) {
        this.reset()
      }
    },


  },
  created() {
    this.uploadStore = useUploadBlockStore();
  },
  methods: {
    isTruthyFlag(value) {
      return value === true || value === 1 || value === '1'
    },
    isFieldRequired(field) {
      return this.isTruthyFlag(field?.required)
    },
    isFieldEditable(field) {
      if (field?.editable === undefined || field?.editable === null) return true
      return this.isTruthyFlag(field.editable)
    },
    isDynamicFieldDisabled(field) {
      return this.isEditMode && !this.isFieldEditable(field)
    },
    getDynamicFieldKey(formId, fieldId) {
      return `${formId}_${fieldId}`
    },
    getDynamicFieldFiles(formId, fieldId) {
      return this.dynamicFieldFiles[this.getDynamicFieldKey(formId, fieldId)] || []
    },
    getExistingDynamicAttachments(formId, fieldId) {
      const value = this.formDataArr?.[formId]?.[fieldId]
      if (!value) return []
      if (Array.isArray(value)) return value
      if (typeof value === 'string') {
        const trimmed = value.trim()
        if (!trimmed) return []
        try {
          const parsed = JSON.parse(trimmed)
          return Array.isArray(parsed) ? parsed : [parsed]
        } catch (e) {
          return trimmed.split(',').map(item => item.trim()).filter(Boolean)
        }
      }
      return [value]
    },
    getDynamicAttachmentDisplayName(file) {
      if (!file) return '-'
      if (typeof file === 'string') return file.split('/').pop() || file
      return file.name || file.file_name || file.file_path || file.path || 'فایل ضمیمه'
    },
    formatDynamicFileSize(bytes) {
      if (!bytes && bytes !== 0) return ''
      if (bytes < 1024) return `${bytes} B`
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
    },
    handleDynamicFieldFiles(formId, field, event) {
      if (this.isDynamicFieldDisabled(field)) return
      const selectedFiles = Array.from(event?.target?.files || [])
      if (!selectedFiles.length) return

      const key = this.getDynamicFieldKey(formId, field.id)
      const multiple = field.multiple === true || field.multiple === 1 || field.multiple === '1'
      this.dynamicFieldFiles[key] = multiple
          ? [...(this.dynamicFieldFiles[key] || []), ...selectedFiles]
          : [selectedFiles[0]]

      if (event?.target) event.target.value = ''
    },
    removeDynamicFieldFile(formId, fieldId, fileIndex) {
      const key = this.getDynamicFieldKey(formId, fieldId)
      if (!Array.isArray(this.dynamicFieldFiles[key])) return
      this.dynamicFieldFiles[key].splice(fileIndex, 1)
    },
    createDynamicTableRow(field) {
      return (field?.options || []).reduce((row, column) => {
        const key = column.key || column.name
        if (!key) return row
        row[key] = ''
        return row
      }, {})
    },
    getTableRows(formId, fieldId) {
      const rows = this.formDataArr?.[formId]?.[fieldId]
      return Array.isArray(rows) ? rows : []
    },
    addDynamicTableRow(formId, field) {
      if (this.isDynamicFieldDisabled(field)) return
      if (!this.formDataArr[formId]) this.formDataArr[formId] = {}
      if (!Array.isArray(this.formDataArr[formId][field.id])) this.formDataArr[formId][field.id] = []
      this.formDataArr[formId][field.id].push(this.createDynamicTableRow(field))
    },
    removeDynamicTableRow(formId, fieldId, rowIndex) {
      const rows = this.getTableRows(formId, fieldId)
      if (rows[rowIndex] !== undefined) rows.splice(rowIndex, 1)
    },
    getTableInputType(type) {
      if (type === 'number') return 'number'
      if (type === 'date') return 'date'
      if (type === 'email') return 'email'
      return 'text'
    },
    normalizeDynamicFieldValue(field) {
      const type = field?.field_type || field?.type
      let value = field?.value ?? field?.default ?? ''

      if (type === 'new_page') return null

      if (type === 'checkbox') {
        if (Array.isArray(value)) return value
        if (typeof value === 'string' && value.trim()) return value.split(',').map(item => item.trim()).filter(Boolean)
        return (field?.options || []).filter(option => this.isTruthyFlag(option?.default)).map(option => option.value)
      }

      if (type === 'radio') {
        if (value !== '' && value !== null && value !== undefined) return value
        return (field?.options || []).find(option => this.isTruthyFlag(option?.default))?.value ?? ''
      }

      if (type === 'multiple_select') {
        if (Array.isArray(value)) return value
        return typeof value === 'string' && value.trim()
            ? value.split(',').map(item => item.trim()).filter(Boolean)
            : []
      }

      if (type === 'attachment') {
        return value || ''
      }

      if (type === 'table') {
        if (Array.isArray(value)) return value
        if (typeof value === 'string' && value.trim()) {
          try {
            const parsed = JSON.parse(value)
            if (Array.isArray(parsed)) return parsed
          } catch (e) {
            // Keep an empty table when an older value is not valid JSON.
          }
        }
        return []
      }

      return value ?? ''
    },
    initializeDynamicForms(forms = [], force = false) {
      (forms || []).forEach(form => {
        if (!this.formDataArr[form.id]) this.formDataArr[form.id] = {}
        ;(form.fields || []).forEach(field => {
          if (force || this.formDataArr[form.id][field.id] === undefined) {
            this.formDataArr[form.id][field.id] = this.normalizeDynamicFieldValue(field)
          }
        })
      })
    },
    isDynamicFieldValueEmpty(form, field) {
      const type = field?.field_type || field?.type
      if (type === 'new_page') return false

      if (type === 'attachment') {
        return this.getExistingDynamicAttachments(form.id, field.id).length === 0 &&
            this.getDynamicFieldFiles(form.id, field.id).length === 0
      }

      const value = this.formDataArr?.[form.id]?.[field.id]
      if (type === 'table') {
        if (!Array.isArray(value) || value.length === 0) return true
        return !value.some(row => Object.values(row || {}).some(cell => cell !== '' && cell !== null && cell !== undefined))
      }

      return value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0)
    },
    hasDynamicFieldValidationError(form, field) {
      const type = field?.field_type || field?.type

      if (this.isFieldRequired(field) && this.isDynamicFieldValueEmpty(form, field)) {
        return true
      }

      if (type === 'table') {
        const rows = this.getTableRows(form.id, field.id)
        if (!rows.length) return false

        return rows.some(row =>
            (field?.options || []).some(column => {
              if (!this.isTruthyFlag(column?.required)) return false
              const key = column.key || column.name
              const value = row?.[key]
              return value === '' || value === null || value === undefined ||
                  (Array.isArray(value) && value.length === 0)
            })
        )
      }

      return false
    },
    getDynamicFieldSubmitValue(form, field) {
      const type = field?.field_type || field?.type
      if (type === 'new_page') return null

      let value = this.formDataArr?.[form.id]?.[field.id]

      if (type === 'attachment') {
        const previous = this.getExistingDynamicAttachments(form.id, field.id).map(file => this.getDynamicAttachmentDisplayName(file))
        const selected = this.getDynamicFieldFiles(form.id, field.id).map(file => file.name)
        return [...previous, ...selected].join(',')
      }
      if (type === 'multiple_select' || type === 'checkbox') {
        return Array.isArray(value) ? value.join(',') : (value ?? '')
      }
      if (type === 'table') {
        return JSON.stringify(Array.isArray(value) ? value : [])
      }
      return value ?? ''
    },
    appendDynamicFieldAttachments(formData, requestIndex) {
      const requestForms = this.acc[requestIndex]?.forms || []
      requestForms.forEach(form => {
        (form.fields || []).forEach(field => {
          if ((field.field_type || field.type) !== 'attachment') return
          this.getDynamicFieldFiles(form.id, field.id).forEach(file => {
            // If your backend expects another multipart key, only this key needs to be changed.
            formData.append(`field_attachments[${field.id}][]`, file)
          })
        })
      })
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }

      const cleanValue = String(value).replace(/,/g, '')
      const [integerPart, decimalPart] = cleanValue.split('.')

      const formattedInteger = integerPart.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
      )

      return decimalPart !== undefined
          ? `${formattedInteger}.${decimalPart}`
          : formattedInteger
    },
    selectFaq(item, index = 0) {
      const current = this.forms[index]
      if (!current) return
      current.answer = current.answer === item.answer ? '' : item.answer
    },
    normalizeEditForms(forms = []) {
      return (forms || []).map(form => ({
        ...form,
        fields: (form.fields || []).map(field => {
          const fieldType = field.field_type || field.type
          let options = Array.isArray(field.options) ? field.options : []
          if (!options.length && typeof field.field_options === 'string') {
            options = field.field_options.split(',').filter(Boolean).map(value => ({value}))
          }
          return {
            ...field,
            field_type: fieldType,
            options
          }
        })
      }))
    },
    hydrateEditMode(payload) {
      if (!payload || !this.isEditMode) return

      const task = payload.task || {}
      const contact = payload.contact || {}
      const creator = payload.creator || {}
      const normalizedForms = this.normalizeEditForms(payload.forms || [])

      this.taskData = task
      this.contactData = contact
      this.previousAttachments = Array.isArray(payload.attachments) ? payload.attachments : []
      this.notes = Array.isArray(payload.notes) ? payload.notes : []
      this.answers = Array.isArray(payload.answers) ? payload.answers : []
      this.audioUrl = payload.audioUrl || payload.audio_url || task.audioUrl || task.audio_url || task.recording_url || ''
      this.cartable_id = task.cartable_id ?? this.cartable_id

      this.creator = {
        fullname: creator.name || creator.fullname || '',
        opr_number: creator.opr_number || '',
        created_at: creator.created_at ? this.toJalali(creator.created_at) : '',
        cartable_title: creator.cartable_title || ''
      }

      if (!this.acc.length) {
        this.acc.push({
          id: task.type_id || 1,
          active: true,
          title: task.type_title || task.type_id_options || 'گروه درخواست',
          titleButton: task.type_title || task.type_id_options || 'گروه درخواست',
          idNode: task.type_id || '',
          forms: normalizedForms
        })
      } else {
        this.acc.splice(0, 1, {
          ...this.acc[0],
          id: task.type_id || this.acc[0].id || 1,
          active: true,
          title: task.type_title || task.type_id_options || this.acc[0].title || 'گروه درخواست',
          titleButton: task.type_title || task.type_id_options || 'گروه درخواست',
          idNode: task.type_id || '',
          forms: normalizedForms
        })
        if (this.acc.length > 1) this.acc.splice(1)
      }

      const tagIds = Array.isArray(task.tags)
          ? task.tags.map(tag => typeof tag === 'object' ? tag.id : tag).filter(Boolean)
          : []

      this.forms[0] = {
        ...this.forms[0],
        code: task.code || contact.code || '',
        type_id: task.type_id || '',
        name: contact.name || '',
        family: contact.family || '',
        meli_code: contact.meli_code || '',
        tel: contact?.phones?.home || contact.home || '',
        phone: contact?.phones?.mobile || contact.mobile || '',
        province: contact.province_id ?? contact.province ?? '',
        city: task.city || contact.city || '',
        tags: tagIds,
        description: task.description || '',
        level: Number.isFinite(+task.level) ? +task.level : 0,
        status_id: task.status_id || '',
        note: '',
        answer: '',
        fileds: '',
        is_closed: Number(task.is_closed) === 0 ? 'باز' : 'بسته',
        answer_attachments: ''
      }

      this.attachment[0] = []
      this.files[0] = []
      this.taskAddedSuccessful[0] = false
      this.disableContact[0].val = true
      this.indexTaskSelected = 0
      this.nodeId = task.type_id || ''

      this.formDataArr = {}
      this.dynamicFieldFiles = {}
      this.initializeDynamicForms(normalizedForms, true)

      if (this.forms[0].province !== '' && this.forms[0].province !== null) {
        this.getTasksLocation(0, this.forms[0].city)
      }
      if (task.type_id) this.getFaqs(task.type_id)
      this.editHydrated = true
    },
    changeSpeed(rate) {
      const audio = document.getElementById('edit-request-audio')
      if (audio) audio.playbackRate = rate
      this.selectedRate = rate
    },
    getFaqs(id) {
      const url = this.apiBaseUrl + 'api/faqs?task_type_id=' + id
      const headers = {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
      axios.get(url, {headers: headers}).then(res => {
        const faqData = res?.data?.data
        this.faqs = Array.isArray(faqData?.data) ? faqData.data : (Array.isArray(faqData) ? faqData : [])
        if (this.faqs[0]) {
          this.faqs[0].active = true
        }


      }).catch(err => {
        const status = err?.response?.status
        if (status === 401) {
          this.logout()
        }
      })
    },
    accToggle(item) {
      const nextState = !item.active
      this.faqs.forEach(acc => acc.active = false)
      item.active = nextState
    },
    findByMelli(melli, index = 0) {
      if (!melli) return
      if (!this.hadafmandi) return
      if (melli.length !== 10) return
      this.indexTaskSelected = index
      this.loadingMelli = true
      axios.get(`${this.apiBaseUrl}api/hadafmandi/person/${melli}`, {headers: this.headers})
          .then(res => {
            this.loadingMelli = false
            this.infoMelli = res.data?.data
            if (this.infoMelli) this.infoMelliForm = this.infoMelli
              this.setMelliInfo()


            this.confirmMelli = true


          })
          .catch(err => {
            console.log(err)
            this.loadingMelli = false
          })

    },
    setMelliInfo() {
      let i = this.indexTaskSelected
      const data = this.infoMelli
      this.infoMelliForm = data
      this.forms[i].name = data?.sarparast_khanvar?.FIRST_NAME || ''
      this.forms[i].family = data?.sarparast_khanvar?.LAST_NAME || ''
      this.forms[i].meli_code = data?.sarparast_khanvar?.NATIONAL_CODE || ''
      this.confirmMelli = false

    },
    selectAttach(index) {
      const input = this.$refs.attachInputs;

      if (Array.isArray(input)) {
        input[index].click();
      }
    },
    submitAudio(file) {
      console.log("فایل دریافت شد:", file);
      this.voiceRecorderModal = false
      this.forms[this.indexTaskSelected].answer_attachments = file
    },
    async downloadFile() {
      let urlBase = this.apiUrl + 'api/voicemails/download/' + this.dataProp.portalInfo.id
      axios.get(urlBase, {
        headers: this.headers,
        responseType: "blob",
      })
          .then((response) => {

            const url = window.URL.createObjectURL(response.data);
            const a = document.createElement("a");
            a.href = url;

            const disposition = response.headers["content-disposition"];
            let fileName = 'file';
            if (disposition && disposition.includes("filename=")) {
              fileName = disposition.split("filename=")[1].replace(/['"]/g, "");
            }

            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error("Error downloading file:", error)
          })
    },
    getLastTasksFunc(index) {
      this.tasksAllShow = true;
      this.indexTaskSelected = index;
      this.taskIdSearch = ''
    },
    handleClickOutside(event) {
      const buttons = this.$refs.addButton;
      if (buttons) {
        const isClickInsideAny = Array.from(buttons).some((el) =>
            el.contains(event.target)
        );
        if (!isClickInsideAny) {
          this.onOutsideClick();
        }
      }

    },
    getContacts(filter = false, page = 1) {
      this.loadingPage = true
      let url = this.apiBaseUrl + 'api/contact?per_page=999'
      if (page !== 1) {
        url = `${this.apiBaseUrl}api/contact?page=${page}&per_page=999`
      }
      let filterUrl = ''
      if (filter) {
        this.tagsFilter.forEach(item => {
          filterUrl += `&${item.name}=${item.value}`
          url += filterUrl
        })

      }

      axios.get(url, {headers: this.headers})
          .then(res => {
            this.loadingPage = false
            if (res.data.status === 'success') {
              this.contactsAll = res.data.data

            } else {
              this.contactsAll = []
            }
          })
          .catch(err => {
            if (err?.response?.status === 401) {
              this.logout()
            }
          })
    },
    onOutsideClick() {
      this.showTree = false
    },
    addNewAcc() {
      this.acc.push({
        id: this.acc.length + 1,
        active: true,
        title: 'گروه درخواستی انتخاب نشده',
        titleButton: 'افزودن گروه درخواست',
        idNode: ''
      })
      this.setTaskType()
    },
    getDate(itemId, fieldId, date) {
      this.formDataArr[itemId][fieldId] = date
    },
    removeTag(index, name = '') {
      this.tagsFilter.splice(index, 1);
      this.filterVals[name] = ''
    },
    userAiResponse() {
      this.aiShow = false;
      let index = this.indexTaskSelected
      this.forms[index].answer = this.aiResponse.suggestion
    },
    ShowTransmissionModal(index) {
      this.transmissionModal = true
      this.userInfo = this.userData
      this.departmentsModel[index].id = this.userInfo.department_id
      this.departmentsModel[index].user = ''
      this.indexTaskSelected = index
    },
    removeAttach(index, f) {
      this.attachment[index].splice(f, 1)
      this.files[index].splice(f, 1)
    },
    downloadAttach(file) {
      file.loading = true

      axios.post(this.apiBaseUrl + 'api/oncestorage/create', {
        path: file.file_path
      }, {
        headers: this.headers
      })
          .then(res => {
            const url = this.apiBaseUrl + 'api/oncestorage/' + res.data.path

            const link = document.createElement('a')
            link.href = url
            link.download = file.file_name || 'downloaded-file'

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)

            file.loading = false
          })
          .catch(err => {
            file.loading = false
            if (err?.response?.status === 401) {
              this.logout()
            } else {
              console.error('Download error:', err)
            }
          })
    },
    async showMelli(index, retry = false) {
      const melli = this.forms[index].meli_code
      if (!melli) {
        this.showMsg('لطفا ابتدا کد ملی را وارد کنید', '#f00')
        return
      }
      if (!this.historyByCode[melli]) {
        this.historyByCode[melli] = {open: false, loading: false, loaded: false, error: false, items: []}
      }
      const history = this.historyByCode[melli]
      history.open = retry || !history.open
      if (!history.open || history.loading || (history.loaded && !retry)) return
      history.loading = true
      history.error = false
      try {
        const res = await axios.get(this.apiBaseUrl + 'api/tasks', {
          headers: this.headers,
          params: {meli_code: melli}
        })
        history.items = Array.isArray(res.data.data) ? res.data.data : []
        history.loaded = true
      } catch {
        history.error = true
      } finally {
        history.loading = false
      }
    },
    getAiModule(index) {

      if (this.forms[index].type_id === '') {
        this.showMsg('لطفا یک گروه درخواست انتخاب کنید!', 'red')
        return
      }
      const fieldMap = [
        {key: "name", label: "نام"},
        {key: "family", label: "نام خانوادگی"},
        {key: "meli_code", label: "کد ملی"},
        {key: "phone", label: "شماره موبایل"},
        {key: "tel", label: "شماره ثابت"},
        {key: "province", label: "استان مبدا تماس"},
        {key: "city", label: "موقعیت مراجع"},
        {key: "level", label: "میزان اهمیت"},
        {key: "status_id", label: "وضعیت"},
        {key: "answer", label: "پاسخ"},
        {key: "description", label: "توضیحات"},
        {key: "note", label: "یادداشت"},
        {key: "fileds", label: "فیلدها"},
        {key: "tags", label: "تگ ها"}
      ];
      let fields = []
      this.acc[index].forms.forEach(form => {
        form?.fields?.forEach(field => {

          const fieldType = field.field_type || field.type
          if (fieldType === 'new_page') return
          const value = this.getDynamicFieldSubmitValue(form, field)
          if (value !== '' && value !== null && value !== undefined) {
            fields.push({key: field.title, value: value})
          }

        })
      })
      this.loadingAiModule = true
      let additional_data = fieldMap
          .filter(field => {
            const val = this.forms[index][field.key];
            return val !== undefined && val !== null && val !== "";
          })
          .map(field => ({
            key: field.label,
            value: this.forms[index][field.key]
          }));
      if (fields.length > 0) {
        additional_data = [...additional_data, ...fields];
      }

      let body = {
        task_type_id: +this.nodeId,
        additional_data: additional_data
      }
      axios.post(this.apiBaseUrl + 'api/ai-modules/by-task-type', body,
          {headers: this.headers}).then(res => {
        this.loadingAiModule = false
        if (res.data.data.length === 0) {
          this.showMsg('هیچ موردی یافت نشد', 'red')
          return
        }
        this.aiModuleShow = true

        this.aiModuleResponse = res.data.data
      }).catch(err => {
        this.loadingAi = false
        this.loadingAiModule = false
        console.log(err)

      })
    },
    recordeVoiceFunc(index) {
      this.indexTaskSelected = index
      this.voiceRecorderModal = true
    },
    getAi(index) {
      let text = this.forms[index].description
      if (this.forms[index].type_id === '') {
        this.showMsg('لطفا یک گروه درخواست انتخاب کنید!', 'red')
        return
      }
      if (text === '') {
        this.showMsg('ابتدا توضیحات خود را وارد کنید', 'red')
        return;
      }


      this.loadingAi = true
      const fieldMap = [
        {key: "name", label: "نام"},
        {key: "family", label: "نام خانوادگی"},
        {key: "meli_code", label: "کد ملی"},
        {key: "phone", label: "شماره موبایل"},
        {key: "tel", label: "شماره ثابت"},
        {key: "province", label: "استان مبدا تماس"},
        {key: "city", label: "موقعیت مراجع"},
        {key: "level", label: "میزان اهمیت"},
        {key: "status_id", label: "وضعیت"},
        {key: "answer", label: "پاسخ"},
        {key: "description", label: "توضیحات"},
        {key: "note", label: "یادداشت"},
        {key: "fileds", label: "فیلدها"},
        {key: "tags", label: "تگ ها"}
      ];
      let fields = []
      this.acc[index].forms.forEach(form => {
        form?.fields?.forEach(field => {

          const fieldType = field.field_type || field.type
          if (fieldType === 'new_page') return
          const value = this.getDynamicFieldSubmitValue(form, field)
          if (value !== '' && value !== null && value !== undefined) {
            fields.push({key: field.title, value: value})
          }

        })
      })
      let additional_data = fieldMap
          .filter(field => {
            const val = this.forms[index][field.key];
            return val !== undefined && val !== null && val !== "";
          })
          .map(field => ({
            key: field.label,
            value: this.forms[index][field.key]
          }));
      if (fields.length > 0) {
        additional_data = [...additional_data, ...fields];
      }

      let body = {
        task_type_id: +this.nodeId,
        input_text: text,
        additional_data: additional_data
      }
      axios.post(this.apiBaseUrl + 'api/ai/suggest-by-category', body,
          {headers: this.headers}).then(res => {
        this.aiShow = true
        this.aiResponse = res.data
        this.loadingAi = false
        this.indexTaskSelected = index
      }).catch(err => {
        this.loadingAi = false
        console.log(err)

      })

    },
    handleFileUpload(index, event) {
      this.indexTaskSelected = index;

      const selectedFiles = Array.from(event.target.files);
      if (selectedFiles.length === 0) return;

      this.files[index].push(...selectedFiles);

      const MAX_SIZE = 1024 * 1024; // 1MB

      this.validationFiles = selectedFiles.map(file => {
        // بررسی نوع فایل با فرمت‌های دقیق‌تر
        const isImage = file.type.startsWith("image/");
        const isVideo = file.type.startsWith("video/");
        const isPdf = file.type === "application/pdf";

        // فقط فرمت‌های خاص برای تصویر
        let isValidImageType = false;
        if (isImage) {
          const allowedImageTypes = [
            "image/jpeg",
            "image/jpg",      // بعضی مرورگرها این را برمی‌گردانند
            "image/png",
            "image/webp"
          ];
          isValidImageType = allowedImageTypes.includes(file.type);
        }

        const isValidType = (isValidImageType) || isVideo || isPdf;

        const isValidSize = file.size <= MAX_SIZE;

        return {
          file: file,
          name: file.name,
          size: (file.size / (1024 * 1024)).toFixed(2) + ' MB',
          type: file.type,
          preview: file.type.startsWith("image/") ? URL.createObjectURL(file) : null,
          isValid: isValidType && isValidSize,
          errors: []
        };
      });

      // پر کردن خطاها
      this.validationFiles.forEach(item => {
        if (!item.isValid) {
          if (!item.isValid) { // قبلاً بررسی نوع
            const isImage = item.file.type.startsWith("image/");

            if (isImage) {
              item.errors.push("فقط فرمت‌های JPG, JPEG, PNG و WEBP برای تصاویر مجاز است");
            } else if (!item.file.type.startsWith("video/") && item.file.type !== "application/pdf") {
              item.errors.push("فرمت فایل مجاز نیست");
            }
          }

          if (item.file.size > MAX_SIZE) {
            item.errors.push("حجم فایل بیشتر از ۱ مگابایت است");
          }
        }
      });

      const allValid = this.validationFiles.every(f => f.isValid);
      if (allValid) {
        this.commitValidFiles();
      } else {
        this.attachInfoModal = true;
      }

      event.target.value = "";
    },
    commitValidFiles() {
      this.validationFiles.forEach(item => {
        if (item.isValid) {
          if (!this.attachment[this.indexTaskSelected]) {
            this.attachment[this.indexTaskSelected] = [];
          }

          this.attachment[this.indexTaskSelected].push({
            name: item.name,
            type: item.type,
            preview: item.preview,
            file: item.file
          });
        }
      });

      this.clearValidation();
      this.showMsg("فایل‌ها با موفقیت اضافه شدند", "green");
    },

    clearValidation() {
      // پاک کردن object URL ها برای جلوگیری از memory leak
      this.validationFiles.forEach(item => {
        if (item.preview) URL.revokeObjectURL(item.preview);
      });
      this.validationFiles = [];
      this.attachInfoModal = false;
    },

    removeValidationFile(index) {
      const item = this.validationFiles[index];
      if (item.preview) URL.revokeObjectURL(item.preview);

      this.validationFiles.splice(index, 1);

      if (this.validationFiles.length === 0) {
        this.clearValidation();
      } else if (this.validationFiles.every(f => f.isValid)) {
        this.commitValidFiles();
      }
    },
    getdepartments() {

      axios.get(this.apiBaseUrl + 'api/departments',
          {headers: this.headers}).then(res => {

        const departmentsData = res?.data?.data
        this.deparments = Array.isArray(departmentsData?.data) ? departmentsData.data : (departmentsData || [])

      }).catch(err => {
        console.log(err)

      })
      axios.get(this.apiBaseUrl + 'api/departments/department-users',
          {headers: this.headers}).then(res => {

        this.departmentUsers = res.data.data


      }).catch(err => {
        console.log(err)

      })
    },
    getProvinces() {

      axios.get(this.apiBaseUrl + 'api/tasks/province',
          {headers: this.headers}).then(res => {
        this.provinces = res?.data?.data


      }).catch(err => {
        console.log(err)

      })
    },
    getTaskTypeFields(id) {
      this.nodeId = id
      if (this.nodeId === '') {
        return
      }
      if (id) {
        axios.get(`${this.apiBaseUrl}api/task/types/${id}/form-field`,
            {headers: this.headers}).then(res => {
          this.fields = res?.data?.data?.data?.forms

          this.acc.forEach((item) => {

            if (item.idNode === id) {
              item.forms = this.fields
              this.initializeDynamicForms(item.forms)
            }

          })


          store.commit('setdisableInput', false)
          this.loadingPage = false


        }).catch(err => {
          console.log(err)

        })
      }

    },
    getTaskLevels() {

      axios.get(this.apiBaseUrl + 'api/tasks/levels',
          {headers: this.headers}).then(res => {
        this.levels = []
        res?.data?.data.forEach((x, index) => {
          this.levels.push({index: index, name: x})
        })

        if (!this.isEditMode) {
          let index = this.acc.length - 1
          if (index >= 0) this.forms[index].level = res?.data?.data[0]
        }


      }).catch(err => {
        console.log(err)

      })
    },
    setTaskType(id = '') {
      this.nodeId = id

      let body = {id: id}
      axios.post(this.apiBaseUrl + 'api/tasks/generate-code', body,
          {headers: this.headers}).then((res) => {
        let index = this.acc.length - 1
        let code = res?.data?.data
        this.forms[index].code = code
        this.forms[index].province = 9
        this.files[index] = []
        this.taskAddedSuccessful[index] = false
        this.showTree = false
        this.getdepartments()
        this.getTasksLocation(index)


      }).catch(err => {
        console.log(err)

      })
    },
    logout() {
      store.commit('setLogout', true);
    },
    removeAcc(index) {

      this.acc.splice(index, 1)

    },

    getTasksLocation(index, preferredCity = null) {
      this.loading = true
      setTimeout(() => {
        let province_id = this.forms[index].province
        let body = {province_id: province_id}
        axios.post(this.apiBaseUrl + 'api/tasks/locations', body,
            {headers: this.headers}).then(res => {
          this.disableCity[index].val = false

          this.cities[index] = res?.data?.data
          this.forms[index].city = preferredCity || (this.isEditMode ? this.forms[index].city : 'تهران')

          this.loading = false
        }).catch(err => {
          console.log(err)

        })
      }, 1000)

    },
    getAccess() {
      if (this.userData) {
        let data = this.userData
        if (data?.data?.features) {

          this.aiAccess = data?.data?.features.some((feature) => feature.name.toLowerCase() === 'artificial_intelligence');
        }
        /* Object.keys(this.accessMenus).forEach((key) => {
           const featureName = key.toLowerCase();
         });*/
      }
    },
    getStatus() {
      this.getAccess()

      axios.get(this.apiBaseUrl + 'api/task/statuses',
          {headers: this.headers}).then(res => {
        this.statuses = res?.data?.data.data
        if (!this.isEditMode && this.statuses[0]) {
          let index = this.acc.length - 1
          this.forms[index].status_id = this.statuses[0].id
        }

      }).catch(err => {
        console.log(err)

      })
    },
    handleSelection2(node, index) {
      let fined = this.acc[index]
      fined.title = node.title
      fined.titleButton = 'گروه درخواست :' + ' ' + node.title
      fined.idNode = node.id
      this.showTree = false
      this.forms[index].type_id = node.id
      this.getTaskTypeFields(node.id)
      /*if (node.isChecked) {
        this.loadingPage = true
        this.setTaskType(node.id)
      }*/


    },
    getTaskInfo(task) {
      task.taskEditLoading = true
      axios.get(this.apiBaseUrl + 'api/tasks/' + task.id,
          {headers: this.headers}).then((res) => {
        let data = res.data.data
        this.setContactInfo2(data.contact)
        this.tasksAllShow = false
        task.taskEditLoading = false
        let index = this.indexTaskSelected
        let fined = this.acc[index]
        fined.title = data.task.type_title
        fined.titleButton = 'گروه درخواست :' + ' ' + data.task.type_title
        fined.idNode = data.task.type_id
        this.getTaskTypeFields(fined.idNode)
        this.showTree = false

        this.forms[index].type_id = data.task.type_id
        this.forms[index].tags = data.task.tags
        this.forms[index].status_id = data.task.status_id
        this.forms[index].is_closed = data.task.is_closed == 1 ? 'بسته' : 'باز'
        this.forms[index].description = data.task.description
        this.related[index] = true
        this.attachment[index] = data.attachments
        this.notes = data.notes
        this.answers = data.answers
        this.cartable_id = data.task.cartable_id
        this.forms[index].city = data.contact.city
      }).catch(err => {
        task.taskEditLoading = true
        this.showMsg('مشکلی پیش آمده', 'red')
        console.log(err)

      })
    },
    getLastTasks(filter = '') {
      let today = moment().format('YYYY-MM-DD')
      this.loadingSearch = true
      let url = this.apiBaseUrl + 'api/tasks?per_page=10&from_date=' + today
      if (filter !== '') {
        url = this.apiBaseUrl + 'api/tasks?per_page=10&id=' + filter
      }


      axios.get(url, {headers: this.headers})
          .then(res => {
            this.lastTasks = res.data.data
            this.loadingSearch = false

          }).catch(() => {
        this.loadingSearch = false
      })
    },
    toJalali(date) {
      return moment(date, 'YYYY-M-D').format('jYYYY/jM/jD')
    },
    submitRequest(index, trans = false) {

      if (this.isEditMode) {
        return this.submitEditRequest(index, trans)
      }
      let error = false
      let rawTags = Array.isArray(this.forms[index].tags) ? this.forms[index].tags : [];
      let tagsArr = rawTags.filter(tag => tag !== "");
      const currentForm = this.forms[index]
      this.confirmChangeContact = false

      if (currentForm.name === '' && currentForm.family === '') {
        this.showMsg('لطفا نام و نام خانوادگی را وارد کنید!', 'red')
        return
      }
      if (currentForm.meli_code?.length !== 10) {
        this.showMsg('لطفا کد ملی را به درستی وارد کنید!', 'red')
        return
      }
      if (currentForm.status_id === '') {
        this.showMsg('لطفا وضعیت را انتخاب کنید!', 'red')
        return
      }
      if (currentForm.description === '') {
        this.showMsg('لطفا توضیحات را وارد کنید!', 'red')
        return
      }
      if (currentForm.city === '' || currentForm.city === null) {
        this.showMsg('لطفا شهر و استان را انتخاب کنید!', 'red')
        return
      }
      if (currentForm.type_id === '' || currentForm.type_id === undefined) {
        this.showMsg('لطفا یک گروه درخواست انتخاب کنید', 'red')
        return
      }

      let fields = []
      if (this.acc[index].forms) {
        this.acc[index].forms.forEach(form => {
          form?.fields?.forEach(field => {
            const fieldType = field.field_type || field.type
            if (fieldType === 'new_page') return

            if (this.hasDynamicFieldValidationError(form, field)) {
              error = true
              return
            }

            fields.push({
              form_id: form.id,
              field_id: field.id,
              value: this.getDynamicFieldSubmitValue(form, field)
            })
          })
        })
      }
      if (error) {
        this.showMsg('لطفا تمام موارد ضروری را وارد کنید!', 'red')
        return;
      }
      const formChanged =
          currentForm.name !== this.contactSelected.name ||
          currentForm.family !== this.contactSelected.family ||
          currentForm.meli_code !== this.contactSelected.meli_code ||
          currentForm.province !== this.contactSelected.province_id ||
          currentForm.phone !== this.contactSelected.phones?.mobile ||
          currentForm.tel !== this.contactSelected.phones?.home

      if (formChanged && this.contactSelected !== '' && this.editContact === 0) {
        this.confirmChangeContact = true
        return;
      }


      this.loading = true
      this.errors = []
      let formData = new FormData();
      if (this.editContact === 1 || this.contactSelected !== '') {
        formData.append('contact_id', this.contactSelected.id);
      }

      formData.append('code', currentForm.code);
      formData.append('type_id', currentForm.type_id);
      formData.append('name', currentForm.name);
      formData.append('family', currentForm.family);
      formData.append('meli_code', currentForm.meli_code);
      if (currentForm.tel) {

        formData.append('home', currentForm.tel);
      }
      formData.append('mobile', currentForm.phone);
      formData.append('province', currentForm.province);
      formData.append('city', currentForm.city);
      formData.append(
          'cartable_id',
          this.isComponent2 ? 1 : this.cartable_id
      );
      /* formData.append('cartable_draft_id', this.cartable_id);*/
      formData.append('description', currentForm.description);
      formData.append('level', currentForm.level);
      formData.append('status_id', currentForm.status_id);
      formData.append('note', currentForm.note);
      formData.append('answer', currentForm.answer);
      if (currentForm.answer_attachments) {
        formData.append('answer_attachments[]', currentForm.answer_attachments);
      }
      if (this.dataProp) {
        formData.append('cartable_draft_id', this.dataProp.portalId);
        if (this.dataProp?.cartable_id === 2) {
          formData.append('voice_mail_id', this.dataProp.portalInfo.id);
        }

      }
      formData.append('fields', JSON.stringify(fields));
      this.appendDynamicFieldAttachments(formData, index);
      formData.append('is_closed', currentForm.is_closed === 'باز' ? 0 : 1);
      tagsArr.forEach(tag => {
        formData.append('tag_ids[]', tag);
      });
      if (this.files[index] !== undefined && this.files[index].length > 0) {
        this.files[index].forEach((file) => {
          formData.append("attachments[]", file);
        });
      }
      if (trans) {
        formData.append('department_id', this.departmentsModel[index].id);
        if (this.userInfo.department_id === this.departmentsModel[index].id) {

          formData.append('assignee_user_id', this.departmentsModel[index].user);
        }
      }
      if (this.isComponent && !this.isVoiceMail) {
        formData.append('portal_id', this.dataProp?.portalId);
      }
      let url = this.apiBaseUrl + 'api/tasks'
      if (this.related[index]) {
        url = this.apiBaseUrl + 'api/tasks/' + this.eventData.task_id
        formData.append('call_id', this.eventData.id);

      }


      console.log('formData',formData)
      axios.post(url, formData,
          {headers: this.headers}).then(() => {
        this.loading = false
        this.transmissionModal = false
        this.showMsg('با موفقیت ثبت شد', 'green')
        this.taskAddedSuccessful[index] = true
        let param = this.$route.params.id
        if (this.isComponent) {
          param = this.cartable_id
        }
        this.$router.push({name: 'TasksComponent', params: {id: param}})
        this.taskAddedSuccessful[index] = false
        this.$emit('close-modal');


      }).catch(err => {
        this.loading = false
        if (err?.response?.data?.errors) {
          this.errors = err?.response?.data?.errors
        }

        if (err?.response?.status === 429) {
          this.uploadStore.block(err.response.data.blocked_until)
          this.attachInfoModal = false
        }

        this.showRequestError(err, index)

      })


    },
    submitEditRequest(index = 0, trans = false) {
      const currentForm = this.forms[index]
      if (!currentForm) return

      this.errors = {}
      if (!currentForm.meli_code || currentForm.meli_code.length !== 10) {
        this.showMsg('لطفا کد ملی را به درستی وارد کنید!', 'red')
        return
      }
      if (currentForm.name === '' && currentForm.family === '') {
        this.showMsg('لطفا نام و نام خانوادگی را وارد کنید!', 'red')
        return
      }
      if (currentForm.status_id === '') {
        this.showMsg('لطفا وضعیت را انتخاب کنید!', 'red')
        return
      }
      if (currentForm.city === '' || currentForm.city === null) {
        this.showMsg('لطفا شهر و استان را انتخاب کنید!', 'red')
        return
      }

      let hasRequiredError = false
      const fields = []
      const requestForms = this.acc[index]?.forms || []
      requestForms.forEach(form => {
        (form.fields || []).forEach(field => {
          const fieldType = field.field_type || field.type
          if (fieldType === 'new_page') return

          if (this.hasDynamicFieldValidationError(form, field)) {
            hasRequiredError = true
          }

          fields.push({
            form_id: form.id,
            field_id: field.id,
            value: this.getDynamicFieldSubmitValue(form, field)
          })
        })
      })

      if (hasRequiredError) {
        this.showMsg('لطفا تمام موارد ضروری را وارد کنید!', 'red')
        return
      }

      const formData = new FormData()
      formData.append('code', this.taskData?.code ?? currentForm.code ?? '')
      if (this.taskInfo?.contact?.id) formData.append('contact_id', this.taskInfo.contact.id)
      formData.append('type_id', this.taskData?.type_id ?? currentForm.type_id ?? '')
      formData.append('name', currentForm.name ?? '')
      formData.append('family', currentForm.family ?? '')
      formData.append('is_closed', currentForm.is_closed === 'باز' ? 0 : 1)
      formData.append('meli_code', currentForm.meli_code ?? '')
      if (currentForm.tel) formData.append('home', currentForm.tel)
      formData.append('mobile', currentForm.phone ?? '')
      formData.append('province', currentForm.province ?? '')
      formData.append('city', currentForm.city ?? '')
      formData.append('description', currentForm.description ?? '')
      formData.append('level', currentForm.level ?? '')
      formData.append('answer', currentForm.answer ?? '')
      formData.append('note', currentForm.note ?? '')
      formData.append('status_id', currentForm.status_id ?? '')
      formData.append('fields', JSON.stringify(fields))
      this.appendDynamicFieldAttachments(formData, index)

      const tags = Array.isArray(currentForm.tags) ? currentForm.tags.filter(Boolean) : []
      tags.forEach(tag => formData.append('tag_ids[]', typeof tag === 'object' ? tag.id : tag))

      if (currentForm.answer_attachments) {
        formData.append('answer_attachments[]', currentForm.answer_attachments)
      }

      const newAttachments = Array.isArray(this.attachment[index]) ? this.attachment[index] : []
      newAttachments.forEach(file => {
        if (file?.file) formData.append('attachments[]', file.file)
      })

      if (trans) {
        formData.append('department_id', this.departmentsModel[index].id)
        if (this.userInfo.department_id === this.departmentsModel[index].id && this.departmentsModel[index].user) {
          formData.append('assignee_user_id', this.departmentsModel[index].user)
        }
      }

      const taskId = this.taskData?.id || this.taskInfo?.task?.id
      if (!taskId) {
        this.showMsg('شناسه درخواست برای ویرایش در دسترس نیست', 'red')
        return
      }

      this.loading = true
      axios.post(this.apiBaseUrl + 'api/tasks/' + taskId, formData, {headers: this.headers})
          .then(res => {
            this.loading = false
            this.transmissionModal = false
            this.attachment[index] = []
            this.files[index] = []
            this.showMsg('با موفقیت ویرایش شد', 'green')
            this.$emit('task-data', res.data.data)
            this.$emit('getList')
          })
          .catch(err => {
            this.loading = false
            if (err?.response?.data?.errors) this.errors = err.response.data.errors
            if (err?.response?.status === 429) {
              this.uploadStore.block(err.response.data.blocked_until)
            }
            this.showRequestError(err, index)
          })
    },
    checkMobile(mobile) {
      const phoneRegex = /^(\+98|0)?9\d{9}$/;
      return phoneRegex.test(mobile)
    },
    setContactInfo(id, i) {
      let data = this.contacts[i].find(x => x.id === id)
      this.forms[i].name = data.name
      this.forms[i].family = data.family
      this.forms[i].meli_code = data.meli_code
      this.forms[i].province = data.province_id
      let phones = data.phones

      this.forms[i].tel = phones.home
      this.getTasksLocation(i)

      this.contactShow = false
    },
    setContactInfo2(contact) {
      let i = this.indexTaskSelected
      this.forms[i].name = contact.name
      this.forms[i].family = contact.family
      this.forms[i].meli_code = contact.meli_code
      this.forms[i].province = contact.province_id
      this.forms[i].phone = contact.phones?.mobile
      this.forms[i].tel = contact.phones?.home
      this.contactSelected = contact

      this.getTasksLocation(i)

      this.contactAllShow = false
    },
    isValidNationalCode(code) {
      if (!/^\d{10}$/.test(code)) return false;

      const check = Number(code[9]);

      let sum = 0;
      for (let i = 0; i < 9; i++) {
        sum += Number(code[i]) * (10 - i);
      }

      const remainder = sum % 11;

      return (
          (remainder < 2 && check === remainder) ||
          (remainder >= 2 && check === 11 - remainder)
      );
    },
    findContact(meli_code, index, first = false) {

      if (meli_code.length !== 10) return
      if (!this.isValidNationalCode(meli_code)) {
        this.showMsg('کد ملی معتبر نیست!', '#f00');
        return;
      }

      this.loadingContact = true
      let body = {meli_code: meli_code}
      this.findByMelli(meli_code, index)
      axios.post(this.apiBaseUrl + 'api/contacts/find', body,
          {headers: this.headers}).then(res => {
        this.contacts[index] = res.data.data
        this.loadingContact = false
        if (this.contacts[index].length > 0) {

          this.disableContact[index].val = false

          if (first) {
            let dataUser = res.data.data[0]
            this.indexTaskSelected = 0
            this.setContactInfo2(dataUser)


          }
        }

      }).catch(err => {
        console.log(err)
      })
    },
    getTree() {

      axios.get(this.apiBaseUrl + 'api/task/types/type-tree',
          {headers: this.headers}).then(res => {
        this.treeData = res.data.data
        const addChecked = nodes => {
          nodes.forEach(node => {
            node.isChecked = false;
            if (node.children && node.children.length) addChecked(node.children);
          });
        };
        addChecked(this.treeData);

      }).catch(err => {
        console.log(err)
      })
    },
    getTags() {
      axios.get(this.apiBaseUrl + 'api/tags',
          {headers: this.headers}).then(res => {
        const tagsData = res?.data?.data
        this.tags = Array.isArray(tagsData?.data) ? tagsData.data : (Array.isArray(tagsData) ? tagsData : [])
        if (!this.isEditMode) {
          const index = this.acc.length - 1
          if (index >= 0 && this.tags[0]) this.forms[index].tags = this.tags[0]
        }
      }).catch(err => {
        console.log(err)
        /*   if (err?.response?.status === 401) {
             this.logout()
           }*/
      })
    },
    checkParameter() {
      let param = this.$route.params.id

      this.cartable_id = param
      if (param === undefined && this.isComponent) {
        this.cartable_id = this.dataProp.cartable_id
      }

      if (!param || isNaN(param)) {
        if (!this.isComponent) {

          this.$router.push({name: 'TasksComponent', params: {id: '0'}});
        }
      }

    },
    onlyNumber(index) {
      this.forms[index].meli_code = this.forms[index]?.meli_code?.replace(/[^0-9]/g, '');
      this.forms[index].tel = this.forms[index]?.tel?.replace(/[^0-9]/g, '');
      this.forms[index].phone = this.forms[index]?.phone?.replace(/[^0-9]/g, '');
    },
    getDataComponent() {

      this.acc = [{
        id: this.dataProp.type_id,
        active: true,
        title: this.dataProp.type_title,
        titleButton: this.dataProp.type_title ?? 'افزودن گروه درخواست'
      }]
      this.acc.forEach((item) => {
        let fields = this.dataProp?.portalInfo?.forms
        item.forms = fields

        this.initializeDynamicForms(fields || [])


      })
      this.getTaskTypeFields(this.dataProp.type_id)
      this.getdepartments()
      this.taskAddedSuccessful[0] = false

      this.forms[0].code = this.dataProp?.portalInfo?.portal?.code
      let contact = this.dataProp?.portalInfo?.contact
      this.forms[0].name = contact?.name ?? contact?.first_name ?? ''
      this.forms[0].family = contact?.family ?? contact?.last_name ?? ''
      this.forms[0].meli_code = contact?.meli_code
      this.forms[0].province = contact?.province_id
      let phones = [];

      if (Array.isArray(contact?.phones)) {
        phones = contact.phones;
      } else {
        try {
          const parsed = JSON.parse(contact?.phones);
          if (Array.isArray(parsed)) {
            phones = parsed;
          }
        } catch (e) {
          phones = [];
        }
      }

      const telItem = phones.find(x => x.name === 'tel');
      const phoneItem = phones.find(x => x.name === 'phone');
      const phone2 = contact?.phone_number || '';

      this.forms[0].tel = telItem?.number || '';
      this.forms[0].phone = phoneItem?.number ?? phone2 ?? '';
      this.forms[0].description = this.dataProp?.portalInfo?.portal?.description
      this.forms[0].level = this.dataProp?.portalInfo?.portal?.level
      this.forms[0].city = this.dataProp?.portalInfo?.portal?.city
      this.forms[0].type_id = this.dataProp?.type_id
      this.attachment[0] = this.dataProp.attachments


    },
    getCookie() {
      return localStorage.getItem('token');
    },
    showMsg(msg, color) {
      this.snackbar = true
      this.textSnack = msg
      this.colorSnack = color
    },
    showRequestError(error, formIndex) {
      const data = error?.response?.data || {}
      const messages = []
      const collectMessages = (value) => {
        if (Array.isArray(value)) {
          value.forEach(collectMessages)
        } else if (value && typeof value === 'object') {
          Object.values(value).forEach(collectMessages)
        } else if (value !== undefined && value !== null && String(value).trim()) {
          messages.push(String(value))
        }
      }

      collectMessages(data.errors)
      if (!messages.length) collectMessages(data.message || data.error)

      this.removeRejectedAttachments(data.errors, messages, formIndex)
      this.showMsg([...new Set(messages)].join('، ') || 'خطایی هنگام ذخیره درخواست رخ داد.', 'red')
    },
    removeRejectedAttachments(errors, messages, formIndex) {
      if (!errors || formIndex === undefined) return

      const fieldNames = Object.keys(errors)
      const hasAttachmentError = fieldNames.some(field => /^(attachments?|files?)(?:\.|\[|$)/i.test(field))
      if (!hasAttachmentError) return

      const attachments = this.attachment[formIndex] || []
      const submittedAttachments = this.isEditMode
          ? attachments.filter(item => item?.file)
          : attachments
      if (!submittedAttachments.length) return

      const rejectedIndexes = new Set()
      const attachmentIndexPattern = /^(?:attachments?|files?)(?:\.|\[)(\d+)/i
      fieldNames.forEach(field => {
        const match = field.match(attachmentIndexPattern)
        if (match) rejectedIndexes.add(Number(match[1]))
      })

      const rejectedAttachments = new Set(
          [...rejectedIndexes]
              .map(fileIndex => submittedAttachments[fileIndex])
              .filter(Boolean)
      )
      const errorText = messages.join(' ').toLowerCase()
      submittedAttachments.forEach(attachment => {
        const name = (attachment?.name || attachment?.file?.name || '').toLowerCase()
        if (name && errorText.includes(name)) rejectedAttachments.add(attachment)
      })

      // When the API returns a general attachment error without an index or filename,
      // every file in the submitted attachment field has been rejected.
      if (!rejectedAttachments.size && fieldNames.some(field => /^(attachments?|files?)$/i.test(field))) {
        submittedAttachments.forEach(attachment => rejectedAttachments.add(attachment))
      }

      rejectedAttachments.forEach(attachment => {
        const file = attachment?.file || attachment
        const fileIndex = this.files[formIndex]?.indexOf(file)
        if (fileIndex >= 0) this.files[formIndex].splice(fileIndex, 1)

        const attachmentIndex = this.attachment[formIndex]?.indexOf(attachment)
        if (attachmentIndex >= 0) this.attachment[formIndex].splice(attachmentIndex, 1)
      })
    },
    debouncedSearch(title, name) {
      const value = this.filterVals[name];
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        const existingTag = this.tagsFilter.find(tag => tag.title === title);

        let displayValue = value;
        let displayValueTitle = value;


        if (!existingTag) {
          this.tagsFilter.push({
            title,
            value: displayValue,
            valueTitle: displayValueTitle,
            name
          });
        } else {
          existingTag.value = displayValue;
          existingTag.valueTitle = displayValueTitle;
        }
      }, 100);
    },
    resetForm() {
      this.acc = []
      this.taskAddedSuccessful.forEach(x => x.val = false)
    },
  },
  mounted() {
    this.resetForm()

    if (this.isEditMode) {
      if (this.taskInfo) this.hydrateEditMode(this.taskInfo)
    } else {
      this.addNewAcc()
      this.checkParameter()
    }

    this.getTree()
    this.getTags()
    this.getProvinces()
    this.getTaskLevels()
    this.getStatus()
    this.getdepartments()
    this.getAccess()

    if (!this.isEditMode) {
      this.getContacts()
      if (this.isComponent) {
        this.getDataComponent()
      }
      if (this.isComponent2) {
        /*  this.findContact(this.eventData.callerid, 0, true)*/
        this.getLastTasks()
      }
    }

    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
}
</script>

<style scoped lang="scss">
.dynamic-form-card {
  width: 100%;
  margin-bottom: 20px;
  background: #ffffff;
  border: 1px solid #e7ebf1;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.035);
  transition: all 0.25s ease;

  &:hover {
    border-color: #dce3ec;
    box-shadow: 0 8px 28px rgba(15, 23, 42, 0.055);
  }
}


/* Header */
.dynamic-form-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;

  padding: 16px 18px;

  background: linear-gradient(
          90deg,
          #f8fafc 0%,
          #ffffff 100%
  );

  border-bottom: 1px solid #edf0f4;

  &__icon {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 11px;

    background: #edf4ff;
    color: #3977de;

    font-size: 17px;
  }

  &__content {
    flex: 1;
    min-width: 0;

    h5 {
      margin: 2px 0 5px;

      color: #253044;

      font-size: 14px;
      font-weight: 700;
      line-height: 1.7;
    }

    p {
      margin: 0;

      color: #8a94a5;

      font-size: 11.5px;
      line-height: 1.8;
    }
  }
}


/* Grid */
.dynamic-fields-grid {
  width: 100%;

  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  gap: 18px 16px;

  padding: 20px 18px 22px;
}


/* Field */
.dynamic-field {
  min-width: 0;

  &--full {
    grid-column: 1 / -1;
  }

  &__label {
    min-height: 22px;

    margin-bottom: 8px;

    display: flex;
    align-items: center;
    gap: 5px;

    color: #475467;

    font-size: 12px;
    font-weight: 600;
  }
}


/* Required */
.required-mark {
  color: #e5484d;
  font-size: 15px;
  font-style: normal;
  line-height: 1;
}


/* Readonly */
.readonly-badge {
  margin-right: auto;
  padding: 3px 7px;

  display: inline-flex;
  align-items: center;
  gap: 4px;

  background: #f1f3f6;

  border-radius: 6px;

  color: #98a2b3;

  font-size: 9px;
  font-weight: 500;

  i {
    font-size: 8px;
  }
}


/* Inputs */
.dynamic-input,
.dynamic-textarea {
  width: 100%;

  border: 1px solid #dfe5ec;
  border-radius: 9px;

  background: #ffffff;

  color: #344054;

  font-size: 12px;

  outline: none;

  transition:
      border-color 0.2s ease,
      box-shadow 0.2s ease,
      background-color 0.2s ease;

  &::placeholder {
    color: #b0b8c4;
  }

  &:focus {
    border-color: #76a7f7;
    box-shadow: 0 0 0 3px rgba(52, 120, 246, 0.09);
  }

  &:disabled {
    opacity: 1;

    background: #f7f8fa;

    border-color: #eaecf0;

    color: #98a2b3;

    cursor: not-allowed;

    -webkit-text-fill-color: #98a2b3;
  }
}

.dynamic-input {
  height: 43px;
  padding: 0 12px;
}

.dynamic-textarea {
  min-height: 110px;
  padding: 12px;

  line-height: 1.8;

  resize: vertical;
}


/* Checkbox + Radio wrapper */
.option-group {
  width: 100%;

  display: flex;
  flex-wrap: wrap;

  gap: 9px;
}


/* each option */
.option-item {
  min-height: 39px;

  padding: 8px 11px;

  display: inline-flex;
  align-items: center;
  gap: 8px;

  background: #fafbfc;

  border: 1px solid #e5e9ef;
  border-radius: 9px;

  color: #475467;

  font-size: 11.5px;

  cursor: pointer;

  transition: all 0.2s ease;

  &:hover {
    background: #f5f8ff;
    border-color: #cfdcf3;
  }

  input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  &--disabled {
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      background: #fafbfc;
      border-color: #e5e9ef;
    }
  }
}


/* Checkbox */
.custom-check {
  width: 18px;
  height: 18px;

  flex: 0 0 18px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;

  border: 1.5px solid #cbd3dd;
  border-radius: 5px;

  color: #fff;

  font-size: 9px;

  transition: all 0.2s ease;

  i {
    opacity: 0;
    transform: scale(0.6);
    transition: 0.2s ease;
  }
}

.option-item input[type="checkbox"]:checked + .custom-check {
  background: #3478f6;
  border-color: #3478f6;

  i {
    opacity: 1;
    transform: scale(1);
  }
}


/* Radio */
.custom-radio {
  position: relative;

  width: 18px;
  height: 18px;

  flex: 0 0 18px;

  background: #fff;

  border: 1.5px solid #cbd3dd;
  border-radius: 50%;

  transition: all 0.2s ease;

  &::after {
    content: '';

    position: absolute;
    inset: 4px;

    background: #3478f6;

    border-radius: 50%;

    opacity: 0;
    transform: scale(0.4);

    transition: 0.2s ease;
  }
}
.faq-search {
  margin-bottom: 1.25rem;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input-wrapper i.fa-magnifying-glass {
  position: absolute;
  right: 14px;
  color: #94a3b8;
  pointer-events: none;
  font-size: 0.95rem;
}

.faq-search-input {
  width: 100%;
  padding: 0.75rem 2.75rem 0.75rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  outline: none;
}

.faq-search-input:focus {
  border-color: #3b82f6;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.clear-search {
  position: absolute;
  left: 12px;
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: color 0.15s;
}

.clear-search:hover {
  color: #64748b;
}

.faq-empty {
  text-align: center;
  padding: 2rem 1rem;
  color: #94a3b8;
  font-size: 0.95rem;
}
.option-item input[type="radio"]:checked + .custom-radio {
  border-color: #3478f6;

  &::after {
    opacity: 1;
    transform: scale(1);
  }
}

.option-text {
  line-height: 1.5;
}


/* Vuetify autocomplete */
.dynamic-autocomplete {
  width: 100%;
}

:deep(.dynamic-autocomplete .v-field) {
  min-height: 43px;

  background: #ffffff;

  border-radius: 9px !important;

  box-shadow: none !important;
}

:deep(.dynamic-autocomplete .v-field__outline) {
  --v-field-border-opacity: 1;

  color: #dfe5ec;
}

:deep(.dynamic-autocomplete .v-field--focused .v-field__outline) {
  color: #76a7f7;
}

:deep(.dynamic-autocomplete .v-field__input) {
  min-height: 43px;

  padding-top: 7px;
  padding-bottom: 7px;

  font-size: 12px;
}

:deep(.dynamic-autocomplete .v-chip) {
  height: 25px;

  background: #edf4ff;

  color: #3569b8;

  border-radius: 6px;

  font-size: 10px;
}


/* Date */
.dynamic-date {
  width: 100%;

  .input-date {
    width: 100%;
  }
}


.dynamic-field__description {
  margin: -3px 0 9px;
  color: #98a2b3;
  font-size: 10.5px;
  line-height: 1.8;
}

/* Structural new-page field */
.dynamic-new-page {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #dfe8f6;
  border-radius: 12px;
  background: linear-gradient(90deg, #f4f8ff 0%, #fbfdff 100%);

  &__icon {
    width: 38px;
    height: 38px;
    flex: 0 0 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #e7f0ff;
    color: #3977de;
  }

  &__content {
    min-width: 0;

    h6 {
      margin: 0;
      color: #344054;
      font-size: 13px;
      font-weight: 700;
    }

    p {
      margin: 4px 0 0;
      color: #8a94a5;
      font-size: 10.5px;
    }
  }
}

/* Dynamic attachment field */
.dynamic-attachment {
  width: 100%;

  &__input {
    position: absolute;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
  }

  &__dropzone {
    min-height: 92px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 16px;
    border: 1.5px dashed #cfd9e8;
    border-radius: 12px;
    background: #fbfcfe;
    cursor: pointer;
    transition: all .2s ease;

    &:hover {
      border-color: #78a5e8;
      background: #f6f9ff;
    }
  }

  &__icon {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 11px;
    background: #edf4ff;
    color: #3977de;
    font-size: 18px;
  }

  &__texts {
    display: flex;
    flex-direction: column;
    gap: 3px;

    strong {
      color: #344054;
      font-size: 12px;
      font-weight: 700;
    }

    small {
      color: #98a2b3;
      font-size: 10px;
    }
  }

  &__list {
    margin-top: 10px;
    display: grid;
    gap: 8px;
  }

  &__file {
    min-height: 44px;
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 8px 10px;
    border: 1px solid #e7ebf1;
    border-radius: 9px;
    background: #fff;
    color: #475467;

    > i {
      color: #6e91c6;
    }

    > div {
      min-width: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 11px;
    }

    small {
      color: #98a2b3;
      font-size: 9px;
    }

    button {
      width: 30px;
      height: 30px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 0;
      border-radius: 7px;
      background: #fff2f2;
      color: #d94b4b;
      transition: .2s ease;

      &:hover:not(:disabled) {
        background: #ffe5e5;
      }
    }

    &.existing {
      background: #f8fafc;

      small {
        margin-right: auto;
      }
    }
  }

  &.is-disabled {
    .dynamic-attachment__dropzone {
      opacity: .65;
      cursor: not-allowed;
      background: #f6f7f9;
    }
  }
}

/* Dynamic table field */
.dynamic-table-section {
  width: 100%;
  border: 1px solid #e7ebf1;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.dynamic-table-scroll {
  width: 100%;
  overflow-x: auto;
}

.dynamic-data-table {
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;

  th {
    padding: 11px 12px;
    background: #f7f9fc;
    border-bottom: 1px solid #e7ebf1;
    color: #475467;
    font-size: 10.5px;
    font-weight: 700;
    text-align: right;
    white-space: nowrap;
  }

  td {
    padding: 9px;
    border-bottom: 1px solid #f0f2f5;
    vertical-align: middle;
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }
}

.dynamic-table-input {
  width: 100%;
  min-width: 130px;
  height: 38px;
  padding: 0 9px;
  border: 1px solid #dfe5ec;
  border-radius: 7px;
  background: #fff;
  color: #344054;
  font-size: 11px;
  outline: none;

  &:focus {
    border-color: #76a7f7;
    box-shadow: 0 0 0 3px rgba(52, 120, 246, .08);
  }

  &:disabled {
    background: #f7f8fa;
    color: #98a2b3;
  }
}

.dynamic-table-actions {
  width: 48px;
  text-align: center !important;
}

.dynamic-table-remove {
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 7px;
  background: #fff2f2;
  color: #d94b4b;

  &:disabled {
    opacity: .45;
    cursor: not-allowed;
  }
}

.dynamic-table-empty {
  padding: 20px !important;
  color: #98a2b3;
  font-size: 11px;
  text-align: center !important;
}

.dynamic-table-add {
  margin: 10px;
  min-height: 36px;
  padding: 7px 12px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #dbe5f4;
  border-radius: 8px;
  background: #f4f8ff;
  color: #3977de;
  font-size: 11px;
  font-weight: 600;

  &:hover:not(:disabled) {
    background: #eaf2ff;
  }

  &:disabled {
    opacity: .45;
    cursor: not-allowed;
  }
}

.dynamic-unsupported-field {
  width: 100%;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #f3dfad;
  border-radius: 9px;
  background: #fffaf0;
  color: #966b17;
  font-size: 11px;
}


/* Responsive */
@media (max-width: 1199px) {
  .dynamic-fields-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .dynamic-form-card {
    border-radius: 12px;
  }

  .dynamic-form-header {
    padding: 14px;
  }

  .dynamic-fields-grid {
    grid-template-columns: 1fr;

    gap: 15px;

    padding: 16px 14px 18px;
  }

  .dynamic-field--full {
    grid-column: auto;
  }

  .option-group {
    flex-direction: column;
  }

  .option-item {
    width: 100%;
  }
}
.payment-history-card {
  width: 100%;
  margin-bottom: 18px;
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.2s ease;

  &:hover {
    border-color: #d8e2ec;
    box-shadow: 0 7px 25px rgba(15, 23, 42, 0.06);
  }

  &__header {
    min-height: 65px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;

    background: linear-gradient(
            90deg,
            #f8fafc 0%,
            #fbfcfd 100%
    );

    border-bottom: 1px solid #edf1f5;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 11px;

    h6 {
      margin: 0 0 3px;
      color: #253044;
      font-size: 13px;
      font-weight: 700;
    }

    span {
      display: block;
      color: #929bad;
      font-size: 10px;
    }
  }

  &__icon {
    width: 40px;
    height: 40px;
    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #edf7f1;
    color: #28a56a;

    border-radius: 10px;
    font-size: 16px;
  }

  &__amount {
    min-width: 150px;
    padding: 7px 13px;

    display: flex;
    flex-direction: column;
    align-items: flex-end;

    background: #edf9f3;
    border: 1px solid #d9f1e4;
    border-radius: 9px;

    span {
      margin-bottom: 2px;
      color: #729282;
      font-size: 10px;
    }

    strong {
      color: #239461;
      font-size: 14px;
      font-weight: 700;
    }
  }

  &__body {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 15px;
    padding: 18px 16px;
  }
}

.payment-field {
  min-width: 0;

  label {
    min-height: 18px;
    margin-bottom: 7px;

    display: flex;
    align-items: center;
    gap: 6px;

    color: #667085;
    font-size: 11px;
    font-weight: 500;

    i {
      width: 15px;
      color: #94a3b8;
      font-size: 11px;
      text-align: center;
    }
  }

  input {
    width: 100%;
    height: 42px;
    padding: 0 12px;

    background: #f8fafc;
    border: 1px solid #e3e8ef;
    border-radius: 8px;

    color: #475467;
    font-size: 12px;
    outline: none;

    transition: all 0.2s ease;

    &:disabled {
      opacity: 1;
      cursor: default;
      color: #475467;
      background: #f8fafc;
      -webkit-text-fill-color: #475467;
    }
  }
}


/* مبلغ محاسبه‌شده */
.amount-field {
  input {
    background: #f5f8ff !important;
    border-color: #e0e8fb;
    color: #48698f !important;
    -webkit-text-fill-color: #48698f !important;
  }
}


/* بدهی */
.debt-field {
  input {
    background: #fff7f7 !important;
    border-color: #f4dddd;
    color: #d05656 !important;
    -webkit-text-fill-color: #d05656 !important;
  }

  label i {
    color: #d96a6a;
  }
}


/* مبلغ پرداخت شده */
.paid-field {
  input {
    background: #f1faf5 !important;
    border-color: #d8eee1;
    color: #258d5d !important;
    font-weight: 600;
    -webkit-text-fill-color: #258d5d !important;
  }

  label i {
    color: #29a66b;
  }
}


@media (max-width: 1200px) {
  .payment-history-card__body {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 992px) {
  .payment-history-card__body {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 576px) {
  .payment-history-card {
    border-radius: 12px;

    &__header {
      align-items: flex-start;
      flex-direction: column;
    }

    &__amount {
      width: 100%;
      align-items: flex-start;
    }

    &__body {
      grid-template-columns: 1fr;
      padding: 14px;
    }
  }
}
.add-btn-attach {
  background: #1f9d62;
  border-radius: 99px;
  color: #fff;
  position: relative;

  a {
    color: #fff;
  }

  input {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    top: 0;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}

.excel-upload-modal {
  border-radius: 20px !important;
}

.excel-icon {
  width: 90px;
  height: 90px;
  margin: auto;
  border-radius: 50%;
  background: #e8f5e9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.excel-icon i {
  font-size: 42px;
  color: #2e7d32;
}

.upload-rules {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.rule-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #f7f8fa;
  text-align: right;
}

.rule-item i {
  color: #2e7d32;
  font-size: 18px;
  min-width: 20px;
}

.rule-item span {
  font-size: 14px;
  color: #444;
}
.bank-card {
  width: 100%;
  margin-bottom: 16px;
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.2s ease;

  &:hover {
    border-color: #d8e2f0;
    box-shadow: 0 6px 22px rgba(15, 23, 42, 0.06);
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 13px 16px;
    background: #f8fafc;
    border-bottom: 1px solid #edf1f5;
  }

  &__icon {
    width: 38px;
    height: 38px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eaf2ff;
    color: #3874dc;
    border-radius: 10px;
    font-size: 16px;
  }

  &__heading {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__title {
    color: #263244;
    font-size: 13px;
    font-weight: 600;
  }

  &__number {
    color: #8a94a6;
    font-size: 11px;
  }

  &__body {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
    padding: 18px 16px;
  }
}

.bank-field {
  min-width: 0;

  label {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 7px;
    color: #667085;
    font-size: 12px;
    font-weight: 500;

    i {
      color: #8ca0bb;
      font-size: 12px;
    }
  }

  input {
    width: 100%;
    height: 42px;
    padding: 0 12px;
    background: #f9fafb;
    border: 1px solid #e4e8ee;
    border-radius: 8px;
    color: #344054;
    font-size: 13px;
    outline: none;
    transition: 0.2s ease;

    &:disabled {
      opacity: 1;
      cursor: default;
      background: #f8fafc;
      color: #475467;
      -webkit-text-fill-color: #475467;
    }
  }
}

@media (max-width: 992px) {
  .bank-card__body {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 576px) {
  .bank-card {
    border-radius: 12px;

    &__body {
      grid-template-columns: 1fr;
      padding: 14px;
    }
  }
}

.dialog-ai .box-modal {
  max-height: calc(100vh - 80px);
  overflow: auto;
  scrollbar-width: thin
}

.ai-response-modal {
  display: flex;
  flex-direction: column;
  max-height: calc(100dvh - 48px);
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 24px;
  background: #fff;
  color: #334155;
  box-shadow: 0 24px 80px rgba(15, 23, 42, .18);
  text-align: right;

  h5, h6, p { margin: 0; }
  h6 { font-size: 13px; font-weight: 700; }
}

.ai-response-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 24px;
  border-bottom: 1px solid #e6edf7;
  background: linear-gradient(120deg, #f5f3ff, #eff7ff);

  h5 { color: #243b64; font-size: 17px; font-weight: 700; }
  p { margin-top: 6px; color: #64748b; font-size: 12px; line-height: 1.8; }
  > .v-btn { margin-inline-start: auto; flex-shrink: 0; }
}

.ai-response-icon {
  display: grid;
  place-items: center;
  flex: 0 0 48px;
  height: 48px;
  border: 1px solid #dbeafe;
  border-radius: 15px;
  background: #fff;
  color: #3977de;
  font-size: 22px;
}

.ai-response-body {
  display: grid;
  gap: 22px;
  min-height: 0;
  padding: 24px;
  overflow-y: auto;
  scrollbar-width: thin;
  overflow-wrap: anywhere;
}

.ai-request-context {
  padding: 16px 18px;
  border: 1px solid #e9edf3;
  border-radius: 14px;
  background: #f8fafc;
  h6 { color: #64748b; }
  p { margin-top: 8px; font-size: 13px; line-height: 2; white-space: pre-wrap; }
}

.ai-suggestion {
  h6 { display: flex; align-items: center; gap: 8px; color: #2864b5; margin-bottom: 12px; }
}

.ai-suggestion-content {
  font-size: 14px;
  line-height: 2.2;
  white-space: pre-wrap;
  :deep(pre) { white-space: pre-wrap; }
  :deep(img) { max-width: 100%; height: auto; }
  :deep(table) { display: block; max-width: 100%; overflow-x: auto; }
}

.ai-sources {
  padding-top: 20px;
  border-top: 1px solid #e8edf3;
  h6 { display: flex; align-items: center; gap: 8px; color: #64748b; margin-bottom: 12px; }
}

.ai-source-list {
  display: grid;
  gap: 8px;
  padding: 0;
  margin: 0;
  list-style: none;
  li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    border: 1px solid #e4eaf5;
    border-radius: 12px;
    background: #f8faff;
  }
}

.ai-source-number {
  display: grid;
  place-items: center;
  flex: 0 0 26px;
  height: 26px;
  border-radius: 8px;
  background: #e8effc;
  color: #3866ad;
  font-size: 12px;
}

.ai-source-text { min-width: 0; white-space: pre-wrap; font-size: 12px; line-height: 2; }
.ai-response-empty { padding: 20px; border-radius: 12px; background: #f8fafc; color: #64748b; line-height: 2; }

.ai-response-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px 24px;
  border-top: 1px solid #e8edf3;
  background: #fbfcfe;
  .v-btn { border-radius: 10px; font-size: 12px; letter-spacing: 0; }
  .ai-dismiss { border-color: #dce3ed; color: #64748b; }
}

@media (max-width: 576px) {
  .ai-response-modal { border-radius: 18px; }
  .ai-response-header { padding: 16px; gap: 10px; h5 { font-size: 15px; } }
  .ai-response-icon { flex-basis: 38px; height: 38px; font-size: 18px; }
  .ai-response-body { padding: 16px; gap: 18px; }
  .ai-response-footer { padding: 14px 16px; flex-wrap: wrap; .v-btn { flex: 1; } }
}

.add-contact {
  background: #ff931e;
  padding: 4px 14px;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;
  transition: all ease .4s;
  &.custom-active{
    background: #297fff;
  }

  &:hover {
    opacity: .7;
  }
}

.contact-all-list {
  max-height: calc(100vh - 40px);
  overflow: auto;
}

.table-section {
  border-radius: 24px;
  border: 1px solid #EDEEF1;
  overflow: auto;
  width: 100%;


  table {

    thead {
      th, td {
        padding: 15px;
        color: #363B44;
        border-bottom: none;
        font-weight: 100;

        i {
          color: #D7DBE0;
        }
      }
    }

    tbody {
      th, td {
        color: #6C798B;
        font-weight: 100;
        padding: 15px;
        vertical-align: middle;
      }

      tr:last-child {
        td, th {
          border-bottom: none;
        }
      }
    }
  }

}

.add-new-button {
  height: 51px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #D7DBE0;
  border-radius: 24px;
  margin-top: 10px;
  cursor: pointer;
  transition: all ease .4s;

  i {
    margin-left: 8px;
  }

  &:hover {
    opacity: .7;
  }
}

.btn-download {
  box-shadow: none;
}

.input-date {
  max-height: 48px;
}

.list-text-data {
  span {
    padding: 10px;
    display: block;
    width: 100%;
    font-size: 14px;
  }
}

.btn-ai-response {
  border: 1px solid #D8F4FF;
  display: flex;
  align-items: center;
  color: #0A75D8;
  font-size: 10px;
  height: 30px;
}

.alert {
  span {
    display: block;
    width: 100%;
    padding: 2px 0;
    font-size: 13px;
  }
}

.tags {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .tag {
    background: #D7DBE0;
    border-radius: 99px;
    padding: 5px 10px;
    font-size: 12px;
    margin-left: 10px;
    display: flex;
    align-items: center;

    i {
      margin-right: 10px;
    }
  }

}

.box-modal {
  position: relative;
  width: 100%;
  background: #fff;
  display: flex;
  flex-wrap: wrap;
  border-radius: 32px;
  padding: 32px;

  .top {
    display: flex;
    align-items: center;
    width: 100%;

    i {
      margin-right: auto;
      width: 25px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  .forms {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .input {
      width: 50%;
      padding: 10px;

      label {
        width: 100%;
        text-align: right;
        padding: 5px 10px;
        margin-bottom: 8px;
      }
    }
  }
}

::placeholder {
  color: #8A96A6;
  opacity: 1; /* Firefox */
}

::-ms-input-placeholder { /* Edge 12 -18 */
  color: #8A96A6;
}


.main-popup {
  padding: 32px;
  .h5-title {
    width: 100%;
    font-size: 16px;
    color: #363B44;
    padding: 10px;
    >span{
      margin-right: auto !important;
    }
  }
  .pop-up {
    padding: 32px;
    border-radius: 32px;
    width: 100%;
    background: #fff;
    box-shadow: 0 0 5px #ccc;
    direction: rtl;

    .head {
      display: flex;
      align-items: center;

      i {
        color: #222;
      }

      .btns-top {
        margin-right: auto;

        button {
          display: flex;
          align-items: center;
          color: #E22C1F;
          margin-left: 15px;
          font-size: 14px;
          cursor: default;

          i {
            border: none !important;

            margin-left: 5px;
          }

        }
      }

      h4 {
        margin-left: auto;
        font-size: 20px;
        color: #363B44
      }
    }

    .form {
      display: flex;
      flex-wrap: wrap;
      direction: rtl;

      p {
        font-size: 14px;
        padding: 0 10px;

      }

      .title {
        .btn-users {
          border: 1px solid #D8F4FF;
          display: flex;
          align-items: center;
          color: #0A75D8;
          font-size: 10px;

        }
      }



      .input {
        width: 33.333%;
        padding: 10px;

        > label {
          width: 100%;
          font-size: 14px;
          color: #3D444F;
          padding: 10px;
        }

        > input, > textarea {
          width: 100%;
          padding: 10px;
          border-radius: 99px;
          border: 1px solid #D7DBE0;
          height: 48px;

          &:disabled {
            background: rgba(238, 238, 238, 0.62);
          }
        }

        &.field-box {
          label em {
            color: red;
          }

          .check-div, .radio-div {
            width: 100%;
            margin-bottom: 5px;
            display: flex;
            flex-wrap: wrap;

            label {
              width: 100%;
              font-size: 14px;
              color: #3D444F;
              padding: 10px;
            }

            > div {
              display: flex;
              align-items: center;
              padding: 5px;

              label {
                margin-bottom: 0;
                padding: 0 4px;
              }
            }
          }

        }
      }

      @media (max-width: 576px) {
        .title {
          flex-wrap: wrap;

          h5 {
            width: 100% !important;
          }

          .btn-users {
            width: 45%;
          }
        }


      }

    }


    .accordion-div {
      direction: rtl;
      padding: 10px;
      @media (max-width: 576px) {
        padding: 0;

      }

      .accordion {
        border: 1px solid #D7DBE0;
        border-radius: 24px;

        margin: 10px 0;

        .head {
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 15px 25px 0;

          span {
            font-size: 16px;
            font-weight: bold;
          }

          i {
            margin-right: auto;
            width: 18px;
            height: 18px;
            border: 2px solid #474F5D;
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          button {
            i {
              color: #E22C1F;
            }
          }
        }

        .form-par {
          display: none;
          padding: 0 15px 15px 15px;
          flex-wrap: wrap;

          form {
            width: 100%;
          }

          &.active {
            display: flex;
          }

          @media (max-width: 576px) {


          }


        }

      }

    }

    .attachments {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      margin-top: 20px;

      h6 {
        font-size: 16px;
        color: #363B44;
      }

      .right-box {
        width: 100%;

        .attach {
          display: flex;
          align-items: center;
          background: #F3F4F6;
          border-radius: 16px;
          padding: 10px;
          margin: 10px 0;

          span {
            margin: 0 5px;
            color: #363B44;
            font-size: 14px;
            max-width: 100%;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          button {
            margin-right: auto;
            color: #E22C1F;
          }

        }

        .btn-upload {
          width: 100%;
          border: 1px solid #0A75D8;
          color: #0A75D8;
          padding: 10px;
          text-align: center;
          border-radius: 99px;
          transition: all ease .4s;
          position: relative;

          input {
            position: absolute;
            right: 0;
            top: 0;
            opacity: 0;
            width: 100%;
            height: 100%;
            left: 0;
            z-index: 1;
            cursor: pointer;

          }

          &.disabled {
            cursor: default;
            color: red;
            border-color: red;

            input {
              cursor: default;
            }
          }

          &:hover {
            opacity: .7;
          }
        }
      }

      .left-box {
        width: 33.333%;
        padding-right: 15px;

        textarea {
          width: 100%;
          height: 190px;
          border: 1px solid #D7DBE0;
          border-radius: 16px;
          padding: 15px;
          transition: all ease .4s;

          &:focus {
            outline: none;
          }
        }

        h6 {
          line-height: 2;
        }
      }

    }
  }


}

.btns-bottom {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-top: 10px;

  .btn-save {
    width: calc(50% - 10px);
  }

  .btn-transmission {
    background: transparent;
    color: #C75407;
    border: 1px solid #C75407;
    width: calc(50% - 10px);
    border-radius: 99px !important;
    padding: 15px !important;
    font-size: 14px !important;
    display: flex !important;
    height: auto !important;
    box-shadow: none;

    &.custom-active {
      color: #297fff;
      border: 1px solid #297fff;
    }

    i {
      margin-left: 10px;
    }
  }
}

.btn-cancel {
  border-radius: 99px !important;
}

.btn-save {
  background: #F07006 !important;
  transition: all ease .4s;

  &.custom-active {
    background: #297fff !important;
  }

  &:hover {
    opacity: .7;
  }
}

.btns-add {
  position: relative;

  .tree-box {
    height: max-content;
    max-height: 300px;
    scrollbar-width: thin;
    width: 300px;
    background: #fff;
    border-radius: 24px;
    top: 60px;
    right: 10px;
    box-shadow: 0 0 5px #ccc;
    overflow: auto;
    padding: 15px;
    z-index: 1;
    position: absolute;
  }

  button {
    direction: rtl;
    background: #24272D;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
    color: #fff;
    border-radius: 99px;
    font-size: 14px;
    transition: all ease .4s;
    bottom: 10px;
    right: 10px;
    z-index: 2;

    &:hover {
      background: #000000;
    }

    i {
      margin-left: 10px;
    }
  }
}

@media (max-width: 767px) {

  .main-popup {
    padding: 10px;

    .pop-up {
      padding: 15px;

      .form {
        .input {
          padding: 0;
          width: 100%;
        }
      }

      .attachments {
        .right-box, .left-box {
          width: 100% !important;
          padding: 10px 0;

          .label {
            flex-wrap: wrap;

            h6 {
              width: 100%;
            }

            button {
              padding: 2px;
              width: 47% !important;
            }

          }
        }
      }
    }
  }

}

/* Unified create/edit visual layer */
.request-view {
  background: #f7f9fc;
  min-height: 100%;

  .pop-up {
    border: 1px solid #e8edf4;
    box-shadow: 0 10px 35px rgba(33, 51, 78, 0.06);
  }

  .pop-up > .head {
    padding-bottom: 18px;
    margin-bottom: 8px;
    border-bottom: 1px solid #eef1f5;
  }

  .accordion-div .accordion {
    border-color: #e5eaf1;
    background: #fff;
    overflow: visible;
    box-shadow: 0 4px 18px rgba(50, 67, 92, 0.035);
  }

  .accordion-div .accordion > .head {
    min-height: 62px;
    padding: 18px 22px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);
    border-radius: 24px 24px 0 0;
  }

  .accordion-div .accordion > .head > span {
    color: #253047;
    font-size: 15px;
  }

  .accordion-div .accordion .form-par {
    padding: 0 22px 22px;
  }

  .h5-title {
    display: flex !important;
    align-items: center;
    gap: 8px;
    margin: 18px 0 12px ;
    padding: 13px 16px !important;
    border: 1px solid #e9edf3;
    border-radius: 12px;
    background: #fafbfd;
    color: #30394b !important;
    font-weight: 700;
  }

  .form .input > input,
  .form .input > textarea,
  .left-box textarea {
    border-color: #dde3eb !important;
    background: #fff;
    transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
  }

  .form .input > input:focus,
  .form .input > textarea:focus,
  .left-box textarea:focus {
    border-color: #7aa7e8 !important;
    box-shadow: 0 0 0 3px rgba(58, 125, 219, .08);
  }

  .attachments {
    padding-top: 8px;
  }

  .attachments .right-box {
    border: 1px solid #edf0f4;
    border-radius: 14px;
    padding: 16px;
    background: #fcfdff;
  }

  .previous-attachments {
    margin-bottom: 10px;
  }

  .previous-attach {
    border: 1px solid #e6ebf2;
    background: #fff !important;
  }

  .locked-request-type {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 58px;
    padding: 10px 15px;
    border: 1px solid #e4e9f0;
    border-radius: 14px;
    background: #f9fbfd;
    color: #465268;
  }

  .locked-request-type > i:first-child {
    width: 36px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #eaf3ff;
    color: #3478d4;
  }

  .locked-request-type small,
  .locked-request-type strong {
    display: block;
  }

  .locked-request-type small {
    margin-bottom: 3px;
    color: #8a95a6;
    font-size: 11px;
  }

  .locked-request-type strong {
    color: #313b4d;
    font-size: 13px;
  }

  .locked-request-type .lock-icon {
    margin-right: auto;
    color: #9ba5b3;
  }

  .btns-bottom {
    position: sticky;
    bottom: 10px;
    z-index: 3;
    gap: 12px;
    padding: 12px;
    border: 1px solid rgba(225, 230, 238, .9);
    border-radius: 18px;
    background: rgba(255, 255, 255, .94);
    backdrop-filter: blur(10px);
    box-shadow: 0 9px 30px rgba(42, 55, 78, .08);
  }
}

.edit-overview-card {
  margin: 12px 10px 18px;
  padding: 18px;
  border: 1px solid #e5eaf1;
  border-radius: 18px;
  background: linear-gradient(135deg, #fbfdff 0%, #ffffff 70%);
}

.edit-overview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;

  .eyebrow {
    display: block;
    margin-bottom: 4px;
    color: #8d98a9;
    font-size: 11px;
  }

  h5 {
    margin: 0;
    color: #2d3749;
    font-size: 15px;
  }
}

.poll-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-width: 58px;
  justify-content: center;
  padding: 8px 11px;
  border-radius: 999px;
  background: #fff7df;
  color: #d89611;
  font-size: 13px;
}

.creator-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.creator-item {
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid #edf0f4;
  border-radius: 12px;
  background: #fff;

  span,
  strong {
    display: block;
  }

  span {
    margin-bottom: 6px;
    color: #8c96a6;
    font-size: 11px;
  }

  strong {
    overflow: hidden;
    color: #3c4657;
    font-size: 12px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.edit-audio-card {
  display: grid;
  grid-template-columns: auto minmax(220px, 1fr) auto;
  align-items: center;
  gap: 14px;
  margin-top: 14px;
  padding: 12px 14px;
  border: 1px solid #e6ebf2;
  border-radius: 13px;
  background: #fff;

  audio {
    width: 100%;
    height: 38px;
  }
}

.audio-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4a5568;
  font-size: 12px;
}

.audio-speeds {
  display: flex;
  align-items: center;
  gap: 5px;

  > span {
    margin-left: 5px;
    color: #7d8798;
    font-size: 10px;
  }

  button {
    min-width: 34px;
    padding: 4px 6px;
    border: 1px solid #e0e5ec;
    border-radius: 8px;
    background: #fff;
    color: #697487;
    font-size: 10px;

    &.active {
      border-color: #4d8ee8;
      background: #edf5ff;
      color: #2e70c9;
    }
  }
}

.national-history {
  margin: 16px 0;
  border: 1px solid #e5eaf1;
  border-radius: 14px;
  overflow: hidden;
  direction: rtl;

  &__toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    padding: 16px;
    background: #fafbfd;
    color: #30394b;
    text-align: right;
    font-weight: 700;
    cursor: pointer;

    &:focus-visible { outline: 2px solid #397ad4; outline-offset: -3px; }
  }

  &__body { padding: 16px; border-top: 1px solid #e5eaf1; }
  &__body > p, [role="alert"] { margin: 0; padding: 16px; text-align: center; color: #626e80; }
  [role="alert"] button { color: #397ad4; text-decoration: underline; }

  :deep(.col-box) {
    flex: 1 1 240px;
    min-width: 0;
    margin: 6px;
    padding: 16px;
    border-color: #e0e7f0;
    border-radius: 12px;
    background: #fbfcfe;
    overflow-wrap: anywhere;
  }

  :deep(h2) { font-size: 16px; }
  :deep(.table-section) { overflow-x: auto; }
}
.faq-section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #e7ebf1;
  border-radius: 14px;
  background: #fbfcfe;

  > div {
    display: flex;
    align-items: center;
    gap: 9px;
    color: #313b4d;
    font-size: 15px;
    font-weight: 700;
  }

  > div i {
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 9px;
    background: #eef5ff;
    color: #397ad4;
  }

  small {
    color: #8a95a6;
    font-size: 10px;
  }
}

.faq-response-row {
  margin: 0;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 2px 0;
  position: relative;
}

.faq-item {
  overflow: hidden;
  border: 1px solid #e5eaf1;
  border-radius: 12px;
  background: #fff;
  transition: border-color .2s ease, box-shadow .2s ease;

  &.active {
    border-color: #cfe0f7;
    box-shadow: 0 5px 16px rgba(53, 98, 160, .07);
  }
}

.faq-question-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
}

.faq-select {
  margin: 0;
  cursor: pointer;

  input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  span {
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dfe5ed;
    border-radius: 8px;
    background: #fff;
    color: transparent;
    transition: all .2s ease;
  }

  input:checked + span {
    border-color: #4f8ee4;
    background: #4f8ee4;
    color: #fff;
  }
}

.faq-toggle {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 2px;
  border: 0;
  background: transparent;
  color: #3b4658;
  text-align: right;
  font-size: 12px;

  > i {
    width: 26px;
    height: 26px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
    background: #f0f4f9;
    color: #728096;
    transition: transform .2s ease;
  }

  > i.rotated {
    transform: rotate(180deg);
  }
}

.faq-answer {
  padding: 0 46px 12px 12px;

  p {
    margin: 0;
    padding: 11px 13px;
    border-radius: 10px;
    background: #f5f8fc;
    color: #626e80;
    font-size: 11px;
    line-height: 1.9;
  }
}

.faq-empty {
  min-height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px dashed #dfe5ed;
  border-radius: 12px;
  color: #929cac;
  font-size: 11px;

  i {
    font-size: 25px;
    color: #b2bbc7;
  }
}

@media (max-width: 992px) {
  .creator-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .edit-audio-card {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .creator-grid {
    grid-template-columns: 1fr;
  }

  .edit-overview-card {
    margin: 8px 0 14px;
    padding: 14px;
  }

  .request-view .btns-bottom {
    position: static;
    flex-direction: column;
  }

  .request-view .btns-bottom .btn-save,
  .request-view .btns-bottom .btn-transmission {
    width: 100%;
    margin: 0 !important;
  }
}

</style>
